(() => {
      window.__mdlBundleEarlyChoiceBridge?.dispose?.();
      if (window.__mdlBundleContentsBound) return;
      window.__mdlBundleContentsBound = true;
      window.__mdlBundleSectionCache = window.__mdlBundleSectionCache || new Map();
      const configElement = document.querySelector('[data-mdl-bundle-runtime-config]');
      let config = {};
      try {
        config = JSON.parse(configElement?.textContent || '{}');
      } catch (error) {
        config = {};
      }
      const BUNDLE_HANDLE = String(config.bundleHandle || '');
      const IS_ONEA_PARURE = BUNDLE_HANDLE === 'parure-onea-percale';
      const PRESERVE_NATIVE_BUNDLE_OPTIONS = BUNDLE_HANDLE === 'pack-couette-2-oreillers-oclassic'
        || BUNDLE_HANDLE === 'pack-couette-2-oreillers-onaturel';
      const CONFIGURABLE_PACK_OPTIONS = PRESERVE_NATIVE_BUNDLE_OPTIONS;
      const BUNDLE_URL = String(config.bundleUrl || '');
      const SIZE_OPTION_NAME = String(config.sizeOptionName || '');
      const PARENT_COLOR_OPTION_NAME = String(config.parentColorOptionName || '');
      const PARENT_COLOR_OPTION_NAMES = Array.isArray(config.parentColorOptionNames) ? config.parentColorOptionNames : [];
      const HIDE_NATIVE_COLOR_OPTION = config.hideNativeColorOption === true;
      const SHOW_SYNCED_SWATCHES = config.showSyncedSwatches !== false;
      const SHOW_GLOBAL_SIZE_SELECTOR = config.showGlobalSizeSelector !== false;
      const HIDE_NATIVE_SIZE_OPTION = config.hideNativeSizeOption === true;
      const PACK_COMPONENTS_ORDER = Array.isArray(config.packComponentsOrder) ? config.packComponentsOrder : [];
      const INDEPENDENT_SIZE_COMPONENTS = Array.isArray(config.independentSizeComponents) ? config.independentSizeComponents : [];
      const COLOR_SWATCH_COMPONENTS = Array.isArray(config.colorSwatchComponents) ? config.colorSwatchComponents : [];
      const SIZE_OPTION_POSITION = Number(config.sizeOptionPosition || 0);
      const PARENT_COLOR_OPTION_POSITION = Number(config.parentColorOptionPosition || 0);
      const SYNCED_COMPONENT_HANDLES = Array.isArray(config.syncedComponentHandles) ? config.syncedComponentHandles : [];
      const VIEW_PRODUCT_TEXT = String(config.viewProductText || '');
      const SIZE_LABEL_TEXT = String(config.sizeLabelText || '');
      const BUNDLE_ATC_TEXT_RAW = String(config.bundleAtcText || '');
      const BUNDLE_UNAVAILABLE_TEXT_RAW = String(config.bundleUnavailableText || '');
      const BUNDLE_UNAVAILABLE_MESSAGE_RAW = String(config.bundleUnavailableMessage || '');
      const storefrontRuntime = {
        loaded: false,
        parentMap: {},
        syncedHandleVariants: {},
      };
      const bundleUiRuntime = {
        timer: null,
        inFlight: false,
        pending: false,
        lastRenderedVariantId: '',
        lastUserSelectedParentVariantId: '',
        swatchSyncLock: false,
        watchdogTimer: null,
        lastWatchdogSignature: '',
        lastWatchdogForceAt: 0,
        renderFailures: 0,
        componentSelections: {},
        loadingToken: 0,
        loadingSafetyTimer: null,
        domRepairTimer: null,
        requestedGlobalSize: '',
        requestedGlobalSizeUntil: 0,
        initialRenderComplete: false,
      };

      const bundleListHeightGuard = {
        style: null,
        height: 0,
        resizeTimer: null,
      };

      function ensureBundleListHeightStyle() {
        if (bundleListHeightGuard.style && bundleListHeightGuard.style.isConnected) {
          return bundleListHeightGuard.style;
        }
        const style = document.createElement('style');
        style.setAttribute('data-mdl-bundle-list-height', '');
        (document.head || document.documentElement).appendChild(style);
        bundleListHeightGuard.style = style;
        return style;
      }

      function measureBundleListNaturalHeight(listNode) {
        const style = ensureBundleListHeightStyle();
        const previous = style.textContent;
        style.textContent = '';
        const height = Math.round(listNode.getBoundingClientRect().height);
        style.textContent = previous;
        return height;
      }

      function syncBundleListHeightGuard() {
        const listNode = document.querySelector('[data-mdl-bundle-runtime-list]');
        if (!listNode) return;
        const hasItems = listNode.querySelectorAll('[data-mdl-bundle-item]').length > 0;
        if (!hasItems) {
          if (bundleListHeightGuard.style) bundleListHeightGuard.style.textContent = '';
          bundleListHeightGuard.height = 0;
          return;
        }
        const naturalHeight = measureBundleListNaturalHeight(listNode);
        if (naturalHeight > 0) bundleListHeightGuard.height = naturalHeight;
        const style = ensureBundleListHeightStyle();
        style.textContent = bundleListHeightGuard.height > 0
          ? `.mdl-bundle-contents__list{min-height:${bundleListHeightGuard.height}px !important;}`
          : '';
      }

      function scheduleBundleListHeightGuardSync() {
        if (bundleListHeightGuard.resizeTimer) window.clearTimeout(bundleListHeightGuard.resizeTimer);
        bundleListHeightGuard.resizeTimer = window.setTimeout(() => {
          bundleListHeightGuard.resizeTimer = null;
          syncBundleListHeightGuard();
        }, 150);
      }

      function installBundleOverlayGeometryGuard() {
        if (window.__mdlBundleOverlayGeometryGuardBound) return;
        window.__mdlBundleOverlayGeometryGuardBound = true;
        let observedOverlay = null;
        let overlayObserver = null;
        let priceOverlay = null;
        let priceOverlaySafetyTimer = null;

        const hidePriceSnapshot = () => {
          if (!priceOverlay) return;
          priceOverlay.style.display = 'none';
          priceOverlay.replaceChildren();
          if (priceOverlaySafetyTimer) {
            window.clearTimeout(priceOverlaySafetyTimer);
            priceOverlaySafetyTimer = null;
          }
        };

        const showPriceSnapshot = () => {
          if (priceOverlay && priceOverlay.style.display === 'block') return;
          const price = document.querySelector('form-controller .pdp-price-block .price');
          if (!price || !document.body) return;
          const rect = price.getBoundingClientRect();
          if (!(rect.width > 0) || !(rect.height > 0)) return;
          if (!priceOverlay) {
            priceOverlay = document.createElement('div');
            priceOverlay.className = 'mdl-bundle-price-loading-overlay';
            priceOverlay.setAttribute('aria-hidden', 'true');
            document.body.appendChild(priceOverlay);
          }
          const clone = price.cloneNode(true);
          clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
          priceOverlay.replaceChildren(clone);
          const backgroundSource = price.closest('.pdp-price-block') || price;
          const backgroundColor = window.getComputedStyle(backgroundSource).backgroundColor;
          priceOverlay.style.position = 'fixed';
          priceOverlay.style.zIndex = '51';
          priceOverlay.style.pointerEvents = 'none';
          priceOverlay.style.overflow = 'hidden';
          priceOverlay.style.top = `${rect.top}px`;
          priceOverlay.style.left = `${rect.left}px`;
          priceOverlay.style.width = `${rect.width}px`;
          priceOverlay.style.height = `${rect.height}px`;
          priceOverlay.style.background = backgroundColor === 'rgba(0, 0, 0, 0)' ? '#fff' : backgroundColor;
          priceOverlay.style.display = 'block';
          priceOverlaySafetyTimer = window.setTimeout(hidePriceSnapshot, 10000);
        };

        const unlockOverlayGeometry = (overlay) => {
          if (!overlay || overlay.classList.contains('is-active')) return;
          overlay.style.minWidth = '';
          overlay.style.minHeight = '';
          delete overlay.dataset.mdlGeometryLocked;
          hidePriceSnapshot();
        };

        const observeOverlay = (overlay) => {
          if (!overlay || overlay === observedOverlay) return;
          if (overlayObserver) overlayObserver.disconnect();
          observedOverlay = overlay;
          overlayObserver = new MutationObserver(() => unlockOverlayGeometry(overlay));
          overlayObserver.observe(overlay, { attributes: true, attributeFilter: ['class'] });
        };

        const lockOverlayGeometry = () => {
          const overlay = document.querySelector('.mdl-bundle-loading-overlay');
          const bundle = document.querySelector('form-controller [data-mdl-bundle-contents]');
          if (!overlay || !bundle) return;
          observeOverlay(overlay);
          showPriceSnapshot();
          if (overlay.dataset.mdlGeometryLocked === 'true') return;
          const rect = bundle.getBoundingClientRect();
          if (!(rect.width > 0) || !(rect.height > 0)) return;
          overlay.style.minWidth = `${rect.width}px`;
          overlay.style.minHeight = `${rect.height}px`;
          overlay.dataset.mdlGeometryLocked = 'true';
        };

        const isBundleControl = (target) => Boolean(
          target instanceof Element
          && (
            target.closest('[data-mdl-bundle-global-size-select]')
            || target.closest('[data-mdl-component-size-select]')
            || target.closest('[data-mdl-swatch]')
          )
        );

        document.addEventListener('change', (event) => {
          if (isBundleControl(event.target)) lockOverlayGeometry();
        }, true);
        document.addEventListener('click', (event) => {
          if (event.target instanceof Element && event.target.closest('[data-mdl-swatch]')) {
            lockOverlayGeometry();
          }
        }, true);
        window.addEventListener('mdl:bundle-loading-state', (event) => {
          if (event.detail && event.detail.loading) lockOverlayGeometry();
        });
        window.addEventListener('mdl:bundle-refresh-state', (event) => {
          if (event.detail && event.detail.active) lockOverlayGeometry();
        });
      }

      if (!IS_ONEA_PARURE) installBundleOverlayGeometryGuard();

      function setBundleLoadingState(isLoading, options) {
        const listNode = document.querySelector('[data-mdl-bundle-runtime-list]');
        if (!listNode) return 0;
        const opts = options && typeof options === 'object' ? options : {};
        const requestedToken = Number(opts.token) || 0;
        const force = Boolean(opts.force);
        const silent = Boolean(opts.silent);
        const activeToken = Number(listNode.dataset.mdlLoadingToken || '0') || 0;
        const hasItems = listNode.querySelectorAll('[data-mdl-bundle-item]').length > 0;
        listNode.dataset.mdlHasItems = hasItems ? 'true' : 'false';
        if (isLoading) {
          window.__mdlBundleLoadingActive = true;
          if (!silent) {
            window.dispatchEvent(new CustomEvent('mdl:bundle-loading-state', { detail: { loading: true } }));
          }
          const token = requestedToken || (bundleUiRuntime.loadingToken + 1);
          bundleUiRuntime.loadingToken = token;
          listNode.dataset.mdlLoadingToken = String(token);
          listNode.dataset.mdlLoading = 'true';
          if (bundleUiRuntime.loadingSafetyTimer) window.clearTimeout(bundleUiRuntime.loadingSafetyTimer);
          bundleUiRuntime.loadingSafetyTimer = window.setTimeout(() => {
            const latestListNode = document.querySelector('[data-mdl-bundle-runtime-list]');
            if (!latestListNode) return;
            const stuckToken = Number(latestListNode.dataset.mdlLoadingToken || '0') || 0;
            if (stuckToken !== token || latestListNode.dataset.mdlLoading !== 'true') return;
            latestListNode.dataset.mdlLoading = 'false';
            scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
          }, 9000);
          return token;
        }
        if (requestedToken && !force && activeToken && requestedToken !== activeToken) {
          return activeToken;
        }
        listNode.dataset.mdlLoading = 'false';
        window.__mdlBundleLoadingActive = false;
        if (!silent) {
          window.dispatchEvent(new CustomEvent('mdl:bundle-loading-state', { detail: { loading: false } }));
        }
        if (force) listNode.dataset.mdlLoadingToken = '0';
        if (bundleUiRuntime.loadingSafetyTimer) {
          window.clearTimeout(bundleUiRuntime.loadingSafetyTimer);
          bundleUiRuntime.loadingSafetyTimer = null;
        }
        return activeToken;
      }

      function safeTranslation(value, fallback) {
        const text = String(value || '').trim();
        if (!text) return fallback;
        if (text.toLowerCase().startsWith('translation missing:')) return fallback;
        return text;
      }
      const BUNDLE_ATC_TEXT = safeTranslation(BUNDLE_ATC_TEXT_RAW, 'Ajouter au panier');
      const BUNDLE_UNAVAILABLE_TEXT = safeTranslation(BUNDLE_UNAVAILABLE_TEXT_RAW, 'Indisponible');
      const BUNDLE_UNAVAILABLE_MESSAGE = safeTranslation(BUNDLE_UNAVAILABLE_MESSAGE_RAW, 'Cette combinaison est indisponible.');
      const PACK_ADVANTAGE_LABEL = 'Avantage pack 15%';
      const PACK_ADVANTAGE_DESCRIPTION = 'Avantage pack : 15 % pour l’achat simultané du matelas et du sommier';
      const PREPRICED_PACK_HANDLES = new Set(['pack-couette-2-oreillers-onaturel', 'pack-couette-2-oreillers-oclassic']);

      function packAdvantageDescription() {
        return PREPRICED_PACK_HANDLES.has(BUNDLE_HANDLE)
          ? 'Avantage pack : 15 % pour l’achat simultané de la couette et des deux oreillers'
          : PACK_ADVANTAGE_DESCRIPTION;
      }

      function buildPackAdvantageBadge() {
        const badgeNode = document.createElement('span');
        badgeNode.className = 'discount-rate mdl-bundle-price__badge mdl-pack-advantage-badge ml-2';

        const labelNode = document.createElement('span');
        labelNode.className = 'mdl-pack-advantage-label';
        labelNode.textContent = PACK_ADVANTAGE_LABEL;

        const triggerNode = document.createElement('button');
        triggerNode.type = 'button';
        triggerNode.className = 'mdl-pack-advantage-trigger';
        triggerNode.setAttribute('aria-label', 'Détails de l’avantage pack de 15 %');
        triggerNode.textContent = '?';

        const popoverNode = document.createElement('span');
        popoverNode.className = 'mdl-pack-advantage-popover';
        popoverNode.setAttribute('role', 'tooltip');
        popoverNode.textContent = packAdvantageDescription();

        badgeNode.append(labelNode, triggerNode, popoverNode);
        return badgeNode;
      }

      function normalizePackAdvantageBadge(badgeNode) {
        if (!badgeNode) return null;
        badgeNode.classList.add('mdl-pack-advantage-badge');
        let labelNode = badgeNode.querySelector('.mdl-pack-advantage-label');
        if (!labelNode) {
          const replacement = buildPackAdvantageBadge();
          badgeNode.replaceChildren(...replacement.childNodes);
          labelNode = badgeNode.querySelector('.mdl-pack-advantage-label');
        }
        if (labelNode && labelNode.textContent !== PACK_ADVANTAGE_LABEL) {
          labelNode.textContent = PACK_ADVANTAGE_LABEL;
        }
        const popoverNode = badgeNode.querySelector('.mdl-pack-advantage-popover');
        if (popoverNode) popoverNode.textContent = packAdvantageDescription();
        return badgeNode;
      }

      const PROMO_RULE_ID = '1900712919387';
      const PROMO_DISCOUNT_RATE = 0.15;
      const PROMO_ELIGIBLE_HANDLES = new Set([
        'ensemble-ciry',
        'ensemble-generique-3',
        'ensemble-generique-4',
        'ensemble-generique-5',
        'ensemble-generique-6',
      ]);

      function getBundleParentPriceAmount() {
        const bundleContents = document.querySelector('[data-mdl-bundle-contents]');
        if (!bundleContents) return 0;
        const parentPriceCents = Number.parseInt(bundleContents.dataset.mdlBundleParentPriceCents || '', 10);
        if (!Number.isFinite(parentPriceCents) || parentPriceCents <= 0) return 0;
        return parentPriceCents / 100;
      }

      function formatBundlePriceAmount(value) {
        const amount = Number(value);
        if (!Number.isFinite(amount)) return '';
        const amountInCents = Math.round(Math.abs(amount) * 100);
        return new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: amountInCents % 100 ? 2 : 0,
          maximumFractionDigits: 2,
        }).format(amount).replace(/[\s\u00A0\u202F]+€$/, '€');
      }

      function syncBundlePriceDisplay(parentVariant) {
        const bundleContents = document.querySelector('[data-mdl-bundle-contents]');
        if (!bundleContents || !parentVariant) return;
        const priceAmount = Number.parseFloat(parentVariant.price || '');
        if (!Number.isFinite(priceAmount) || priceAmount <= 0) return;
        bundleContents.dataset.mdlBundleParentPriceCents = String(Math.round(priceAmount * 100));
        const regularPriceLabel = formatBundlePriceAmount(priceAmount);
        const compareAmount = Number.parseFloat(parentVariant.compareAtPrice || '');
        const comparePriceLabel = Number.isFinite(compareAmount) && compareAmount > 0
          ? formatBundlePriceAmount(compareAmount)
          : '';
        document.querySelectorAll('.pdp-price-block .price, .sticky-add-to-cart .price, .product-sticky-atc .price').forEach((priceNode) => {
          const regularNode = priceNode.querySelector('.regular-price');
          if (regularNode && regularPriceLabel) regularNode.textContent = regularPriceLabel;
          const compareNode = priceNode.querySelector('.compare-price');
          if (compareNode && comparePriceLabel) compareNode.textContent = comparePriceLabel;
        });
      }

      function computePackPricingFromVariantPrice() {
        if (!PROMO_ELIGIBLE_HANDLES.has(BUNDLE_HANDLE)) return null;
        const fullPrice = getBundleParentPriceAmount();
        if (!(fullPrice > 0)) return null;
        const discountedPrice = Math.round((fullPrice * (1 - PROMO_DISCOUNT_RATE)) * 100) / 100;
        return {
          fullPrice,
          discountedPrice,
          signature: `${PROMO_RULE_ID}|${fullPrice.toFixed(2)}|${discountedPrice.toFixed(2)}`,
        };
      }

      function clearPackAdvantageBadge(priceNode) {
        if (!priceNode) return;
        delete priceNode.dataset.mdlPackPriceSignature;
        const compareNode = priceNode.querySelector('.compare-price');
        const badgeNode = priceNode.querySelector('.discount-rate.mdl-bundle-price__badge');
        if (compareNode) compareNode.remove();
        if (badgeNode) badgeNode.remove();
      }

      function applyPackAdvantageBadgeLabel() {
        if (IS_ONEA_PARURE) return;
        const packPriceNodes = document.querySelectorAll('.pdp-price-block .price, .sticky-add-to-cart .price, .product-sticky-atc .price');
          const formatEuroAmount = (value) => {
            const amountInCents = Math.round(Math.abs(value || 0) * 100);
            return new Intl.NumberFormat('fr-FR', {
              style: 'currency',
              currency: 'EUR',
              minimumFractionDigits: amountInCents % 100 ? 2 : 0,
              maximumFractionDigits: 2,
            }).format(value || 0).replace(/[\s\u00A0\u202F]+€$/, '€');
          };
        packPriceNodes.forEach((priceNode) => {
          const regularNode = priceNode.querySelector('.regular-price');
          if (!regularNode) return;
          const packPricing = computePackPricingFromVariantPrice();
          if (!packPricing) {
            if (PREPRICED_PACK_HANDLES.has(BUNDLE_HANDLE)) {
              const existingBadge = priceNode.querySelector('.discount-rate');
              if (existingBadge) normalizePackAdvantageBadge(existingBadge);
            } else {
              clearPackAdvantageBadge(priceNode);
            }
            return;
          }
          if (priceNode.dataset.mdlPackPriceSignature === packPricing.signature) return;

          let compareNode = priceNode.querySelector('.compare-price');
          if (!compareNode) {
            compareNode = document.createElement('del');
            compareNode.className = 'compare-price text-base-content';
            regularNode.insertAdjacentElement('beforebegin', compareNode);
          }
          const fullPriceLabel = formatEuroAmount(packPricing.fullPrice);
          const discountedPriceLabel = formatEuroAmount(packPricing.discountedPrice);
          if (compareNode.textContent !== fullPriceLabel) {
            compareNode.textContent = fullPriceLabel;
          }
          if (regularNode.textContent !== discountedPriceLabel) {
            regularNode.textContent = discountedPriceLabel;
          }

          let badgeNode = priceNode.querySelector('.discount-rate.mdl-bundle-price__badge');
          if (!badgeNode) {
            badgeNode = buildPackAdvantageBadge();
            priceNode.appendChild(badgeNode);
          }
          normalizePackAdvantageBadge(badgeNode);
          priceNode.dataset.mdlPackPriceSignature = packPricing.signature;
        });

        const badges = document.querySelectorAll('.price .discount-rate');
        badges.forEach((badge) => {
          if (!PROMO_ELIGIBLE_HANDLES.has(BUNDLE_HANDLE) && !PREPRICED_PACK_HANDLES.has(BUNDLE_HANDLE) && !badge.classList.contains('mdl-bundle-price__badge')) return;
          if (PREPRICED_PACK_HANDLES.has(BUNDLE_HANDLE)) {
            normalizePackAdvantageBadge(badge);
            return;
          }
          const currentLabel = String(badge.textContent || '').trim();
          const match = currentLabel.match(/^-([0-9]{1,2})%$/);
          if (!match) return;
          badge.textContent = `Avantage pack ${match[1]}%`;
        });
      }
      function applyPackAdvantageBadgeLabelDeferred() {
        window.requestAnimationFrame(() => {
          applyPackAdvantageBadgeLabel();
          window.setTimeout(applyPackAdvantageBadgeLabel, 80);
          window.setTimeout(applyPackAdvantageBadgeLabel, 240);
        });
      }

      function applyPackVocabulary() {
        if (BUNDLE_HANDLE !== 'ensemble-generique-3') return;
        const selectors = [
          'h1',
          '.breadcrumb a',
          '.breadcrumb li',
          '.mdl-bundle-contents__title',
        ];
        document.querySelectorAll(selectors.join(',')).forEach((node) => {
          const text = String(node.textContent || '');
          if (!text) return;
          if (!/ensemble/i.test(text)) return;
          node.textContent = text.replace(/ensemble/gi, 'Pack');
        });
      }

      function applyPackVocabularyDeferred() {
        if (BUNDLE_HANDLE !== 'ensemble-generique-3') return;
        window.requestAnimationFrame(() => {
          applyPackVocabulary();
          window.setTimeout(applyPackVocabulary, 80);
          window.setTimeout(applyPackVocabulary, 240);
        });
      }

      function escapeHtml(input) {
        return String(input || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function getStorefrontToken() {
        const node = document.getElementById('shopify-features');
        if (!node) return '';
        try {
          const payload = JSON.parse(node.textContent || '{}');
          return payload.accessToken || '';
        } catch (error) {
          return '';
        }
      }

      function getStorefrontApiUrl() {
        const myshopifyDomain = (window.Shopify && Shopify.shop) ? Shopify.shop : '';
        if (!myshopifyDomain) return '';
        return `https://${myshopifyDomain}/api/2025-07/graphql.json`;
      }

      async function storefrontQuery(query, variables) {
        const token = getStorefrontToken();
        const url = getStorefrontApiUrl();
        if (!token || !url) return null;
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token,
          },
          body: JSON.stringify({ query, variables: variables || {} }),
        });
        if (!response.ok) throw new Error('Storefront API request failed');
        const payload = await response.json();
        if (payload.errors) throw new Error('Storefront API GraphQL errors');
        return payload.data || null;
      }

      function selectedOptionValue(selectedOptions, optionNameHint) {
        const list = Array.isArray(selectedOptions) ? selectedOptions : [];
        const hint = (optionNameHint || '').trim().toLowerCase();
        if (!hint) return '';
        const exact = list.find((option) => String(option.name || '').trim().toLowerCase() === hint);
        if (exact) return exact.value || '';
        const contains = list.find((option) => String(option.name || '').trim().toLowerCase().includes(hint));
        return contains ? (contains.value || '') : '';
      }

      function selectedOptionValueFromHints(selectedOptions, optionNameHints) {
        const hints = Array.isArray(optionNameHints) ? optionNameHints : [];
        for (const hint of hints) {
          const value = selectedOptionValue(selectedOptions, hint);
          if (value) return value;
        }
        return '';
      }

      function normalizeParentVariants(productData) {
        const parentMap = {};
        const colorOptionHints = Array.from(new Set(
          [...(Array.isArray(PARENT_COLOR_OPTION_NAMES) ? PARENT_COLOR_OPTION_NAMES : []), PARENT_COLOR_OPTION_NAME, 'couleur']
            .map((value) => String(value || '').trim())
            .filter(Boolean)
        ));
        const variants = (((productData || {}).product || {}).variants || {}).nodes || [];
        variants.forEach((variant) => {
          const parentId = String(variant.id || '').split('/').pop();
          if (!parentId) return;
          const size = selectedOptionValue(variant.selectedOptions, SIZE_OPTION_NAME) || selectedOptionValue(variant.selectedOptions, 'taille') || ((variant.selectedOptions || [])[0] || {}).value || '';
          const color = selectedOptionValueFromHints(variant.selectedOptions, colorOptionHints);
          const components = (((variant.components || {}).nodes) || []).map((component) => {
            const child = component.productVariant || {};
            const product = child.product || {};
            return {
              quantity: Number(component.quantity || 1),
              variantId: String(child.id || '').split('/').pop(),
              variantTitle: child.title || '',
              price: child.price && child.price.amount ? child.price.amount : '',
              compareAtPrice: child.compareAtPrice && child.compareAtPrice.amount ? child.compareAtPrice.amount : '',
              variantAvailable: Boolean(child.availableForSale),
              variantImage: (child.image && child.image.url) || '',
              selectedOptions: child.selectedOptions || [],
              productHandle: product.handle || '',
              productTitle: product.title || '',
              productType: product.productType || '',
              productUrl: product.onlineStoreUrl || '',
              productDescriptionHtml: product.descriptionHtml || '',
              productFeaturedImage: (product.featuredImage && product.featuredImage.url) || '',
            };
          });
          parentMap[parentId] = {
            id: parentId,
            title: variant.title || '',
            size,
            color: color || '',
            price: variant.price && variant.price.amount ? variant.price.amount : '',
            compareAtPrice: variant.compareAtPrice && variant.compareAtPrice.amount ? variant.compareAtPrice.amount : '',
            options: (variant.selectedOptions || []).map((option) => String(option.value || '').trim()).filter(Boolean),
            components,
          };
        });
        return parentMap;
      }

      function normalizeSyncedVariants(productData) {
        const product = (productData || {}).product || {};
        const handle = product.handle || '';
        const productOptions = Array.isArray(product.options) ? product.options : [];
        const colorOptionHints = Array.from(new Set(
          [...(Array.isArray(PARENT_COLOR_OPTION_NAMES) ? PARENT_COLOR_OPTION_NAMES : []), PARENT_COLOR_OPTION_NAME, 'couleur']
            .map((value) => String(value || '').trim().toLowerCase())
            .filter(Boolean)
        ));
        const swatchByColorLabel = new Map();
        productOptions.forEach((option) => {
          const optionName = String((option && option.name) || '').trim().toLowerCase();
          if (!optionName) return;
          const isColorOption = colorOptionHints.some((hint) => optionName === hint || optionName.includes(hint));
          if (!isColorOption) return;
          const optionValues = Array.isArray(option && option.optionValues) ? option.optionValues : [];
          optionValues.forEach((optionValue) => {
            const label = String((optionValue && optionValue.name) || '').trim().toLowerCase();
            if (!label) return;
            const swatch = optionValue && optionValue.swatch ? optionValue.swatch : null;
            if (swatch && (swatch.color || (swatch.image && swatch.image.url)) && !swatchByColorLabel.has(label)) {
              swatchByColorLabel.set(label, swatch);
            }
          });
        });
        const variants = ((product.variants || {}).nodes || []).map((variant) => {
          const selectedOptions = variant.selectedOptions || [];
          const colorLabel = selectedOptionValueFromHints(selectedOptions, colorOptionHints);
          const nativeSwatch = swatchByColorLabel.get(String(colorLabel || '').trim().toLowerCase()) || null;
          return {
            id: String(variant.id || '').split('/').pop(),
            title: variant.title || '',
            available: Boolean(variant.availableForSale),
            image: (variant.image && variant.image.url) || '',
            selectedOptions,
            nativeSwatch,
          };
        });
        return { handle, variants };
      }

      async function ensureRuntimeBundleData() {
        if (storefrontRuntime.loaded) return storefrontRuntime;
        const parentQuery = `
          query BundleRuntime($handle: String!) {
            product(handle: $handle) {
              variants(first: 100) {
                nodes {
                  id
                  title
                  price { amount }
                  compareAtPrice { amount }
                  selectedOptions { name value }
                  components(first: 20) {
                    nodes {
                      quantity
                      productVariant {
                        id
                        title
                        price { amount }
                        compareAtPrice { amount }
                        availableForSale
                        selectedOptions { name value }
                        image { url }
                        product {
                          handle
                          title
                          productType
                          onlineStoreUrl
                          descriptionHtml
                          featuredImage { url }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `;
        const parentData = await storefrontQuery(parentQuery, { handle: BUNDLE_HANDLE });
        storefrontRuntime.parentMap = normalizeParentVariants(parentData);

        const allComponentHandles = Array.from(new Set(
          Object.values(storefrontRuntime.parentMap || {})
            .flatMap((parentVariant) => Array.isArray(parentVariant && parentVariant.components) ? parentVariant.components : [])
            .map((component) => String((component && component.productHandle) || '').trim())
            .filter(Boolean)
        ));
        const syncedQuery = `
            query SyncedVariants($handle: String!) {
              product(handle: $handle) {
                handle
                variants(first: 100) {
                  nodes {
                    id
                    title
                    availableForSale
                    image { url }
                    selectedOptions { name value }
                  }
                }
              }
            }
          `;
        await Promise.all(allComponentHandles.map(async (handle) => {
          const syncedData = await storefrontQuery(syncedQuery, { handle });
          const normalized = normalizeSyncedVariants(syncedData);
          if (normalized.handle) storefrontRuntime.syncedHandleVariants[normalized.handle] = normalized.variants;
        }));
        storefrontRuntime.loaded = true;
        return storefrontRuntime;
      }

      function unlockBundleModalScroll() {
        document.documentElement.classList.remove('mdl-bundle-modal-open');
        document.body.classList.remove('mdl-bundle-modal-open');
      }

      function getSwatchElements(swatchRoot) {
        return swatchRoot ? Array.from(swatchRoot.querySelectorAll('[data-mdl-swatch]')) : [];
      }

      function isSwatchUnavailable(swatchButton) {
        return swatchButton && swatchButton.dataset.mdlBundleUnavailable === 'true';
      }

      function setBundleThumb(card, imageUrl) {
        if (!card || !imageUrl) return;
        const thumb = card.querySelector('img[data-mdl-bundle-thumb]');
        if (!thumb) return;
        thumb.src = imageUrl;
        thumb.srcset = imageUrl;
      }

      function setBundleModalImage(card, imageUrl) {
        if (!card || !imageUrl) return;
        const modalId = card.dataset.mdlBundleModalTarget || '';
        if (!modalId) return;
        const modal = document.getElementById(modalId);
        if (!modal) return;
        const modalImage = modal.querySelector('img[data-mdl-bundle-modal-image]');
        if (!modalImage) return;
        modalImage.src = imageUrl;
        modalImage.srcset = imageUrl;
      }

      function setSwatchSelection(swatchRoot, swatchButton) {
        if (!swatchRoot || !swatchButton) return;
        if (isSwatchUnavailable(swatchButton)) return;
        const nextHandle = swatchButton.dataset.swatchHandle || '';
        const nextImage = swatchButton.dataset.swatchImage || '';
        const nextModalImage = swatchButton.dataset.swatchModalImage || nextImage;
        const nextVariantId = swatchButton.dataset.swatchVariantId || '';
        const nextLabel = swatchButton.dataset.swatchLabel || '';
        swatchRoot.dataset.selectedHandle = nextHandle;
        swatchRoot.dataset.selectedImage = nextImage;
        swatchRoot.dataset.selectedModalImage = nextModalImage;
        const card = swatchRoot.closest('[data-mdl-bundle-item]');
        if (card && nextVariantId) card.dataset.mdlBundleVariantId = nextVariantId;
        const variantLabel = card ? card.querySelector('.mdl-bundle-item__size') : null;
        if (variantLabel && nextLabel) variantLabel.textContent = nextLabel;
        getSwatchElements(swatchRoot).forEach((button) => {
          const isActive = button === swatchButton;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function applySwatchPreview(swatchRoot, swatchButton) {
        if (!swatchRoot || !swatchButton) return;
        if (isSwatchUnavailable(swatchButton)) return;
        const card = swatchRoot.closest('.mdl-bundle-item');
        const previewImage = swatchButton.dataset.swatchImage || '';
        const previewModalImage = swatchButton.dataset.swatchModalImage || previewImage;
        setBundleThumb(card, previewImage);
        setBundleModalImage(card, previewModalImage);
      }

      function restoreSelectedSwatchPreview(swatchRoot) {
        if (!swatchRoot) return;
        const card = swatchRoot.closest('.mdl-bundle-item');
        const activeSwatch = getSwatchElements(swatchRoot).find((button) => button.classList.contains('is-active'))
          || getSwatchElements(swatchRoot).find((button) => button.getAttribute('aria-pressed') === 'true')
          || null;
        if (activeSwatch) {
          const activeImage = activeSwatch.dataset.swatchImage || '';
          const activeModalImage = activeSwatch.dataset.swatchModalImage || activeImage;
          if (activeSwatch.dataset.swatchHandle) swatchRoot.dataset.selectedHandle = activeSwatch.dataset.swatchHandle;
          swatchRoot.dataset.selectedImage = activeImage;
          swatchRoot.dataset.selectedModalImage = activeModalImage;
        }
        const selectedImage = swatchRoot.dataset.selectedImage || '';
        const selectedModalImage = swatchRoot.dataset.selectedModalImage || selectedImage;
        setBundleThumb(card, selectedImage);
        setBundleModalImage(card, selectedModalImage);
      }

      let parentVariantMapCache = null;
      let parentVariantMapSource = null;

      function getParentVariantMap() {
        const source = document.querySelector('[data-mdl-bundle-parent-variant-map]');
        if (!source) return {};
        if (parentVariantMapCache && parentVariantMapSource === source && parentVariantMapSource.isConnected) {
          return parentVariantMapCache;
        }
        try {
          parentVariantMapCache = JSON.parse(source.textContent || '{}');
        } catch (error) {
          parentVariantMapCache = {};
        }
        parentVariantMapSource = source;
        return parentVariantMapCache;
      }

      /*
        Fallback intentionally kept commented for quick rollback.
        Strict mode now relies on Shopify native bundle runtime only (variant.components).

      function getNativeBundleComponentsMap() {
        const source = document.querySelector('[data-mdl-bundle-native-components-map]');
        if (!source) return {};
        try { return JSON.parse(source.textContent || '{}'); } catch (error) { return {}; }
      }

      const productJsonCache = new Map();

      async function fetchProductJson(handle) {
        const key = String(handle || '').trim();
        if (!key) return null;
        if (productJsonCache.has(key)) return productJsonCache.get(key);
        const request = fetch(`/products/${encodeURIComponent(key)}.js`, {
          method: 'GET',
          headers: { 'Accept': 'application/json' },
        }).then((response) => {
          if (!response.ok) throw new Error(`Product JSON fetch failed for ${key}`);
          return response.json();
        }).catch(() => null);
        productJsonCache.set(key, request);
        return request;
      }

      async function fallbackComponentsForParentVariant(parentVariantId) {
        const id = String(parentVariantId || '').trim();
        if (!id) return [];
        const nativeMap = getNativeBundleComponentsMap();
        const entries = Array.isArray(nativeMap[id]) ? nativeMap[id] : [];
        if (!entries.length) return [];

        const components = [];
        for (const entry of entries) {
          const handle = String((entry || {}).handle || '').trim();
          const variantId = String((entry || {}).variant_id || '').trim();
          const quantity = Number((entry || {}).quantity || 1);
          if (!handle || !variantId) continue;
          const product = await fetchProductJson(handle);
          if (!product) continue;
          const variants = Array.isArray(product.variants) ? product.variants : [];
          const variant = variants.find((candidate) => String(candidate.id) === variantId);
          const imageSrc = (variant && variant.featured_image && variant.featured_image.src)
            || (product.featured_image || '');
          const selectedOptions = [];
          const optionNames = Array.isArray(product.options) ? product.options : [];
          const optionValues = Array.isArray(variant && variant.options) ? variant.options : [];
          optionValues.forEach((value, index) => {
            selectedOptions.push({
              name: String(optionNames[index] || `Option ${index + 1}`),
              value: String(value || ''),
            });
          });
          components.push({
            quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
            variantId,
            variantTitle: String((variant && variant.public_title) || (variant && variant.name) || ''),
            variantAvailable: Boolean(variant && variant.available),
            variantImage: imageSrc,
            selectedOptions,
            productHandle: handle,
            productTitle: String(product.title || handle),
            productUrl: `/products/${handle}`,
            productDescriptionHtml: String(product.description || ''),
            productFeaturedImage: String(product.featured_image || ''),
          });
        }
        return components;
      }
      */

      function getCurrentParentVariantId() {
        const variantInputs = Array.from(document.querySelectorAll('form[action*="/cart/add"] input[name="id"], input[name="id"]'));
        for (const input of variantInputs) {
          const candidate = input && input.value ? String(input.value).split('/').pop() : '';
          if (!candidate) continue;
          if (candidate === 'undefined' || candidate === 'null') continue;
          if (!/^\d+$/.test(candidate)) continue;
          return candidate;
        }
        return '';
      }

      function optionValueIdsFromQueryString() {
        const params = new URLSearchParams(window.location.search || '');
        const raw = params.get('option_values') || '';
        return raw
          .split(',')
          .map((entry) => String(entry || '').trim())
          .filter(Boolean);
      }

      function variantIdFromQueryString() {
        const params = new URLSearchParams(window.location.search || '');
        const raw = String(params.get('variant') || '').trim();
        if (!/^\d+$/.test(raw)) return '';
        return raw;
      }

      function optionValueIdsFromVariantInputs() {
        return Array.from(document.querySelectorAll('variant-selector input[name^="option"]:checked'))
          .map((input) => String(input.value || '').trim())
          .filter(Boolean);
      }

      function parentVariantIdByOptionValueIds(optionValueIds) {
        const expected = new Set((optionValueIds || []).map((value) => String(value || '').trim()).filter(Boolean));
        if (!expected.size) return '';
        const entries = Object.entries(getParentVariantMap());
        for (const [variantId, variant] of entries) {
          if (!variant || !Array.isArray(variant.option_value_ids)) continue;
          const current = new Set(variant.option_value_ids.map((value) => String(value || '').trim()).filter(Boolean));
          if (!current.size || current.size !== expected.size) continue;
          const allMatch = Array.from(expected).every((value) => current.has(value));
          if (allMatch) return variantId;
        }
        return '';
      }

      function activeVariantSyncedSwatchColor() {
        const activeParent = document.querySelector('[data-mdl-variant-synced-swatches][data-mdl-swatch-mode="parent"] [data-mdl-swatch].is-active');
        if (activeParent) return String(activeParent.dataset.swatchHandle || '').trim();

        const activeComponent = document.querySelector('[data-mdl-variant-synced-swatches][data-mdl-swatch-mode="component"] [data-mdl-swatch].is-active');
        if (activeComponent) return String(activeComponent.dataset.swatchHandle || '').trim();

        const selectedRootParent = document.querySelector('[data-mdl-variant-synced-swatches][data-mdl-swatch-mode="parent"][data-selected-handle]');
        const selectedParentHandle = selectedRootParent ? String(selectedRootParent.dataset.selectedHandle || '').trim() : '';
        if (selectedParentHandle) return selectedParentHandle;

        const selectedRootComponent = document.querySelector('[data-mdl-variant-synced-swatches][data-mdl-swatch-mode="component"][data-selected-handle]');
        return selectedRootComponent ? String(selectedRootComponent.dataset.selectedHandle || '').trim() : '';
      }

      function activeVariantSyncedSwatchParentVariantId() {
        const active = document.querySelector('[data-mdl-variant-synced-swatches][data-mdl-swatch-mode="parent"] [data-mdl-swatch].is-active');
        if (!active) return '';
        return String(active.dataset.swatchParentVariantId || '').trim();
      }

      function selectedVariantSizeValue() {
        const optionName = `option${Number(SIZE_OPTION_POSITION || 1)}`;
        const selected = Array.from(document.querySelectorAll('variant-selector input[name^="option"]:checked'))
          .find((input) => String(input.name || '').trim() === optionName);
        if (!selected) return '';
        const selector = selected.closest('label');
        if (!selector) return '';
        const label = selector.textContent || '';
        return String(label).trim();
      }

      function selectedGlobalSizeValue() {
        const select = document.querySelector('[data-mdl-bundle-global-size-select]');
        if (!select) return '';
        return String(select.value || '').trim();
      }

      function selectedRequestedGlobalSizeValue() {
        const runtimeSize = String(bundleUiRuntime.requestedGlobalSize || '').trim();
        if (runtimeSize && Date.now() < Number(bundleUiRuntime.requestedGlobalSizeUntil || 0)) return runtimeSize;
        const select = document.querySelector('[data-mdl-bundle-global-size-select]');
        if (!select) return '';
        return String(select.dataset.mdlRequestedSize || '').trim();
      }

      function setRequestedGlobalSizeValue(size, duration) {
        const requestedSize = String(size || '').trim();
        if (!requestedSize) return;
        bundleUiRuntime.requestedGlobalSize = requestedSize;
        bundleUiRuntime.requestedGlobalSizeUntil = Date.now() + (Number(duration) || 3000);
        const select = document.querySelector('[data-mdl-bundle-global-size-select]');
        if (select) select.dataset.mdlRequestedSize = requestedSize;
      }

      function clearRequestedGlobalSizeValue(size) {
        const requestedSize = String(size || '').trim();
        if (requestedSize && String(bundleUiRuntime.requestedGlobalSize || '').trim() !== requestedSize) return;
        bundleUiRuntime.requestedGlobalSize = '';
        bundleUiRuntime.requestedGlobalSizeUntil = 0;
        const select = document.querySelector('[data-mdl-bundle-global-size-select]');
        if (select && (!requestedSize || String(select.dataset.mdlRequestedSize || '').trim() === requestedSize)) {
          delete select.dataset.mdlRequestedSize;
        }
      }

      function normalizeColorValue(value) {
        const raw = String(value || '').trim().toLowerCase();
        if (!raw) return '';
        const normalized = raw
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/\s+/g, ' ')
          .trim();
        if (normalized === 'anthracite' || normalized === 'gris fonce' || normalized === 'gris foncee') return 'anthracite';
        if (normalized === 'beige') return 'beige';
        if (normalized === 'marron' || normalized === 'brown') return 'marron';
        if (normalized === 'gris') return 'gris';
        return normalized;
      }

      function findParentVariantIdBySize(size, preferredColor) {
        const expectedSize = String(size || '').trim();
        if (!expectedSize) return '';
        const preferred = normalizeColorValue(preferredColor);
        const entries = Object.entries(getParentVariantMap());
        if (preferred) {
          for (const [variantId, variant] of entries) {
            if (!variant) continue;
            if (String(variant.size || '').trim() !== expectedSize) continue;
            if (normalizeColorValue(variant.color) !== preferred) continue;
            return variantId;
          }
        }
        for (const [variantId, variant] of entries) {
          if (!variant) continue;
          if (String(variant.size || '').trim() !== expectedSize) continue;
          return variantId;
        }
        return '';
      }

      function parentVariantOptionValues(parentVariant) {
        return Array.isArray(parentVariant && parentVariant.options)
          ? parentVariant.options.map((value) => String(value || '').trim()).filter(Boolean)
          : [];
      }

      function selectedLocalComponentSizeConstraints() {
        const values = Array.from(document.querySelectorAll('[data-mdl-component-size-select]'))
          .map((select) => String(select.value || '').trim())
          .filter(Boolean);
        return Array.from(new Set(values));
      }

      function parentVariantMatchesLocalSizeConstraints(parentVariant, localSizeConstraints) {
        const constraints = Array.isArray(localSizeConstraints) ? localSizeConstraints : selectedLocalComponentSizeConstraints();
        if (!constraints.length) return true;
        const options = parentVariantOptionValues(parentVariant);
        if (!options.length) return false;
        return constraints.every((value) => options.includes(value));
      }

      function normalizeParentVariantOptionValue(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/\s+/g, ' ')
          .trim();
      }

      function configurablePackOptionParts(value) {
        const parts = String(value || '').trim().split(/\s*[—-]\s*/);
        return {
          format: String(parts.shift() || '').trim(),
          firmness: String(parts.join(' — ') || '').trim(),
        };
      }

      function configurablePackFieldset(hints) {
        return optionFieldsetsWithLegendHints(hints).find((fieldset) => !fieldset.matches('[data-mdl-pack-choice-firmness]')) || null;
      }

      function configurablePackControls() {
        if (!CONFIGURABLE_PACK_OPTIONS) return null;
        const sizeControl = document.querySelector('[data-mdl-pack-choice-size]');
        const firmnessControl = document.querySelector('[data-mdl-pack-choice-firmness]');
        const sizeSelect = sizeControl?.querySelector('[data-mdl-pack-combined-select]') || null;
        return sizeSelect && firmnessControl ? { sizeControl, sizeSelect, firmnessControl } : null;
      }

      function configurablePackNativeValue(fieldset) {
        const input = fieldset?.querySelector('input[name^="option"]:checked');
        if (!input) return '';
        const label = input.parentElement?.querySelector('label') || input.closest('label');
        return String(label?.textContent || input.value || '').trim();
      }

      function configurablePackCardValue(selector) {
        const checked = document.querySelector(`${selector}:checked`);
        if (checked) return String(checked.value || '').trim();
        const selectSelector = selector.includes('heat')
          ? '[data-mdl-pack-card-heat-select]'
          : '[data-mdl-pack-card-firmness-select]';
        return String(document.querySelector(selectSelector)?.value || '').trim();
      }

      function findConfigurablePackVariant(size, pillowFormat, firmness, heat) {
        if (!CONFIGURABLE_PACK_OPTIONS) return null;
        const expectedSize = normalizeParentVariantOptionValue(size);
        const expectedFormat = normalizeParentVariantOptionValue(pillowFormat);
        const expectedFirmness = normalizeParentVariantOptionValue(firmness);
        const expectedHeat = normalizeParentVariantOptionValue(heat);
        const entries = Object.entries(getParentVariantMap());
        const matches = entries.filter(([, variant]) => {
          const options = Array.isArray(variant?.options) ? variant.options : [];
          const pillow = configurablePackOptionParts(options[2]);
          return (!expectedSize || normalizeParentVariantOptionValue(options[0]) === expectedSize)
            && (!expectedHeat || normalizeParentVariantOptionValue(options[1]) === expectedHeat)
            && (!expectedFormat || normalizeParentVariantOptionValue(pillow.format) === expectedFormat)
            && (!expectedFirmness || normalizeParentVariantOptionValue(pillow.firmness) === expectedFirmness);
        });
        if (!matches.length) return null;
        const available = matches.find(([, variant]) => variant && variant.available !== false);
        const selected = available || matches[0];
        return selected ? { id: selected[0], variant: selected[1] } : null;
      }

      function syncConfigurablePackControlsFromParentVariant(parentVariant) {
        if (!CONFIGURABLE_PACK_OPTIONS || !parentVariant) return;
        const controls = configurablePackControls();
        if (!controls) return;
        const options = Array.isArray(parentVariant.options) ? parentVariant.options : [];
        const pillow = configurablePackOptionParts(options[2]);
        const size = String(options[0] || parentVariant.size || '').trim();
        const sizeMatch = Array.from(controls.sizeSelect.options).find((option) => (
          normalizeParentVariantOptionValue(option.dataset.mdlPackSize) === normalizeParentVariantOptionValue(size)
          && normalizeParentVariantOptionValue(option.dataset.mdlPackPillowFormat) === normalizeParentVariantOptionValue(pillow.format)
        ));
        if (sizeMatch && controls.sizeSelect.value !== sizeMatch.value) controls.sizeSelect.value = sizeMatch.value;
        const firmness = normalizeParentVariantOptionValue(pillow.firmness);
        controls.firmnessControl.querySelectorAll('[data-mdl-pack-firmness-option]').forEach((input) => {
          input.checked = normalizeParentVariantOptionValue(input.value) === firmness;
        });
        document.querySelectorAll('[data-mdl-pack-card-heat-option]').forEach((input) => {
          input.checked = normalizeParentVariantOptionValue(input.value) === normalizeParentVariantOptionValue(options[1]);
        });
        document.querySelectorAll('[data-mdl-pack-card-firmness-option]').forEach((input) => {
          input.checked = normalizeParentVariantOptionValue(input.value) === firmness;
        });
        const heatSelect = document.querySelector('[data-mdl-pack-card-heat-select]');
        if (heatSelect) heatSelect.value = String(options[1] || '').trim();
        const firmnessSelect = document.querySelector('[data-mdl-pack-card-firmness-select]');
        if (firmnessSelect) firmnessSelect.value = String(pillow.firmness || '').trim();
        syncConfigurablePackChoiceAvailability();
      }

      function setConfigurablePackChoiceAvailability(input, unavailable) {
        const label = input.closest('label');
        if (label) {
          label.classList.toggle('is-unavailable', unavailable);
          label.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
        }
        input.disabled = unavailable;
        input.dataset.mdlPackUnavailable = unavailable ? 'true' : 'false';
      }

      function syncConfigurablePackChoiceAvailability() {
        if (!CONFIGURABLE_PACK_OPTIONS) return;
        const controls = configurablePackControls();
        if (!controls) return;
        const selectedOption = controls.sizeSelect.options[controls.sizeSelect.selectedIndex];
        if (!selectedOption) return;
        const current = getCurrentParentVariant() || getParentVariantById(getCurrentParentVariantId());
        const currentPillow = configurablePackOptionParts(current?.options?.[2]);
        const heat = configurablePackCardValue('[data-mdl-pack-card-heat-option]')
          || configurablePackNativeValue(configurablePackFieldset(['chaleur']))
          || String(current?.options?.[1] || '').trim();
        const firmness = configurablePackCardValue('[data-mdl-pack-card-firmness-option]')
          || String(controls.firmnessControl.querySelector('[data-mdl-pack-firmness-option]:checked')?.value || currentPillow.firmness || '').trim();
        document.querySelectorAll('[data-mdl-pack-firmness-option], [data-mdl-pack-card-firmness-option]').forEach((input) => {
          const match = findConfigurablePackVariant(
            selectedOption.dataset.mdlPackSize,
            selectedOption.dataset.mdlPackPillowFormat,
            input.value,
            heat
          );
          setConfigurablePackChoiceAvailability(input, !match || match.variant.available === false);
        });
        const cardFirmnessSelect = document.querySelector('[data-mdl-pack-card-firmness-select]');
        if (cardFirmnessSelect) {
          Array.from(cardFirmnessSelect.options).forEach((option) => {
            const match = findConfigurablePackVariant(
              selectedOption.dataset.mdlPackSize,
              selectedOption.dataset.mdlPackPillowFormat,
              option.value,
              heat
            );
            option.disabled = !match || match.variant.available === false;
          });
        }
        document.querySelectorAll('[data-mdl-pack-card-heat-option]').forEach((input) => {
          const match = findConfigurablePackVariant(
            selectedOption.dataset.mdlPackSize,
            selectedOption.dataset.mdlPackPillowFormat,
            firmness,
            input.value
          );
          setConfigurablePackChoiceAvailability(input, !match || match.variant.available === false);
        });
        const cardHeatSelect = document.querySelector('[data-mdl-pack-card-heat-select]');
        if (cardHeatSelect) {
          Array.from(cardHeatSelect.options).forEach((option) => {
            const match = findConfigurablePackVariant(
              selectedOption.dataset.mdlPackSize,
              selectedOption.dataset.mdlPackPillowFormat,
              firmness,
              option.value
            );
            option.disabled = !match || match.variant.available === false;
          });
        }
      }

      function syncConfigurablePackVariantFromControls() {
        if (!CONFIGURABLE_PACK_OPTIONS || window.__mdlPackChoiceSyncing) return false;
        const controls = configurablePackControls();
        if (!controls) return false;
        const selectedOption = controls.sizeSelect.options[controls.sizeSelect.selectedIndex];
        if (!selectedOption) return false;
        const nativeHeat = configurablePackFieldset(['chaleur']) || null;
        const current = getCurrentParentVariant() || getParentVariantById(getCurrentParentVariantId());
        const currentPillow = configurablePackOptionParts(current?.options?.[2]);
        const heat = configurablePackCardValue('[data-mdl-pack-card-heat-option]')
          || configurablePackNativeValue(nativeHeat)
          || String(current?.options?.[1] || '').trim();
        const firmnessInput = document.querySelector('[data-mdl-pack-card-firmness-option]:checked')
          || controls.firmnessControl.querySelector('[data-mdl-pack-firmness-option]:checked');
        const firmness = String(document.querySelector('[data-mdl-pack-card-firmness-select]')?.value || firmnessInput?.value || currentPillow.firmness || '').trim();
        const next = findConfigurablePackVariant(
          selectedOption.dataset.mdlPackSize,
          selectedOption.dataset.mdlPackPillowFormat,
          firmness,
          heat
        );
        if (!next || !next.variant) return false;
        const nextParentVariant = Object.assign({}, next.variant, { id: next.id });
        window.__mdlPackChoiceSyncing = true;
        try {
          const committed = commitParentVariantSelection(nextParentVariant);
          if (committed) {
            bundleUiRuntime.lastRenderedVariantId = '';
            scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
          }
          return committed;
        } finally {
          window.setTimeout(() => {
            window.__mdlPackChoiceSyncing = false;
          }, 0);
        }
      }

      function markConfigurablePackNativeOptions() {
        if (!CONFIGURABLE_PACK_OPTIONS) return;
        const heatFieldset = configurablePackFieldset(['chaleur']);
        if (heatFieldset) {
          heatFieldset.classList.add('mdl-pack-native-heat');
          const heatLabel = heatFieldset.querySelector('legend span');
          if (heatLabel) heatLabel.textContent = 'Chaleur de la couette';
        }
        const pillowFieldset = configurablePackFieldset(['oreillers', 'oreiller']);
        if (!pillowFieldset) return;
        pillowFieldset.classList.add('mdl-pack-native-pillow');
        pillowFieldset.setAttribute('aria-hidden', 'true');
        pillowFieldset.querySelectorAll('input, select, button, label').forEach((control) => {
          control.setAttribute('tabindex', '-1');
        });
      }

      function positionConfigurablePackControls() {
        if (!CONFIGURABLE_PACK_OPTIONS) return;
        const controls = configurablePackControls();
        if (!controls) return;
        const heatFieldset = configurablePackFieldset(['chaleur']);
        const targetParent = heatFieldset?.parentElement || document.querySelector('variant-selector form') || document.querySelector('variant-selector');
        if (!targetParent) return;
        if (heatFieldset && heatFieldset.parentElement === targetParent) {
          targetParent.insertBefore(controls.sizeControl, heatFieldset);
        } else {
          targetParent.insertBefore(controls.sizeControl, targetParent.firstChild);
        }
        const bundleRoot = document.querySelector('[data-mdl-bundle-contents]');
        const bundleList = bundleRoot?.querySelector('[data-mdl-bundle-runtime-list]');
        if (bundleRoot && bundleList && controls.firmnessControl.parentElement !== bundleRoot) {
          bundleRoot.insertBefore(controls.firmnessControl, bundleList);
        }
        controls.sizeControl.dataset.mdlPackChoicePositioned = 'true';
        controls.firmnessControl.dataset.mdlPackChoicePositioned = 'true';
      }

      function getNativeSelectedParentVariant() {
        if (!PRESERVE_NATIVE_BUNDLE_OPTIONS) return null;
        const selectedOptions = {};
        document.querySelectorAll('variant-selector input[name^="option"]:checked').forEach((input) => {
          const match = /^option(\d+)$/.exec(String(input.name || '').trim());
          if (!match) return;
          const label = input.parentElement?.querySelector('label') || input.closest('label');
          const value = String(label?.textContent || '').trim();
          if (value) selectedOptions[Math.max(0, Number(match[1]) - 1)] = value;
        });
        const selectedIndexes = Object.keys(selectedOptions).map((value) => Number(value));
        if (!selectedIndexes.length) return null;
        const matches = Object.entries(getParentVariantMap()).filter(([, variant]) => {
          const options = Array.isArray(variant?.options) ? variant.options : [];
          return selectedIndexes.every((index) => normalizeParentVariantOptionValue(options[index]) === normalizeParentVariantOptionValue(selectedOptions[index]));
        });
        const availableMatch = matches.find(([, variant]) => variant && variant.available !== false);
        const match = availableMatch || matches[0];
        return match ? match[1] : null;
      }

      function findParentVariantIdBySizePreservingOptions(size, currentVariant, preferredColor, localSizeConstraints) {
        if (!PRESERVE_NATIVE_BUNDLE_OPTIONS) return '';
        const expectedSize = String(size || '').trim();
        const expectedColor = normalizeColorValue(preferredColor);
        const constraints = Array.isArray(localSizeConstraints) ? localSizeConstraints : selectedLocalComponentSizeConstraints();
        const matches = Object.entries(getParentVariantMap()).filter(([, variant]) => {
          if (!variant) return false;
          if (expectedSize && String(variant.size || '').trim() !== expectedSize) return false;
          if (expectedColor && normalizeColorValue(variant.color) !== expectedColor) return false;
          return parentVariantMatchesLocalSizeConstraints(variant, constraints);
        });
        const currentOptions = Array.isArray(currentVariant?.options) ? currentVariant.options : [];
        const sizeIndex = Math.max(0, Number(SIZE_OPTION_POSITION || 1) - 1);
        const preserved = currentOptions.length
          ? matches.filter(([, variant]) => {
              const nextOptions = Array.isArray(variant?.options) ? variant.options : [];
              if (nextOptions.length !== currentOptions.length) return false;
              return currentOptions.every((value, index) => (
                index === sizeIndex
                || normalizeParentVariantOptionValue(nextOptions[index]) === normalizeParentVariantOptionValue(value)
              ));
            })
          : matches;
        const chosen = preserved.find(([, variant]) => variant && variant.available !== false)
          || preserved[0]
          || matches.find(([, variant]) => variant && variant.available !== false)
          || matches[0];
        return chosen ? chosen[0] : '';
      }

      function findParentVariantIdBySizeColorAndLocalConstraints(size, preferredColor, localSizeConstraints) {
        const expectedSize = String(size || '').trim();
        const expectedColor = normalizeColorValue(preferredColor);
        const constraints = Array.isArray(localSizeConstraints) ? localSizeConstraints : selectedLocalComponentSizeConstraints();
        const matches = Object.entries(getParentVariantMap()).filter(([, variant]) => {
          if (!variant) return false;
          if (expectedSize && String(variant.size || '').trim() !== expectedSize) return false;
          if (expectedColor && normalizeColorValue(variant.color) !== expectedColor) return false;
          return parentVariantMatchesLocalSizeConstraints(variant, constraints);
        });
        const availableMatch = matches.find(([, variant]) => variant.available);
        const firstMatch = availableMatch || matches[0];
        return firstMatch ? firstMatch[0] : '';
      }

      function findParentVariantIdForComponentVariant(componentVariant) {
        if (!componentVariant) return '';
        const requestedComponentSize = String(variantSizeValue(componentVariant)).trim();
        if (!requestedComponentSize) return '';
        const constraints = Array.from(new Set([...selectedLocalComponentSizeConstraints(), requestedComponentSize]));
        const inputParent = getParentVariantById(getCurrentParentVariantId());
        const expectedSize = selectedGlobalSizeValue() || (inputParent ? inputParent.size : '');
        const expectedColor = activeVariantSyncedSwatchColor() || (inputParent ? inputParent.color : '');
        return findParentVariantIdBySizeColorAndLocalConstraints(expectedSize, expectedColor, constraints)
          || findParentVariantIdBySizeColorAndLocalConstraints(expectedSize, '', constraints)
          || findParentVariantIdBySizeColorAndLocalConstraints('', expectedColor, constraints)
          || findParentVariantIdBySizeColorAndLocalConstraints('', '', constraints);
      }

      function commitParentVariantForComponentVariant(componentVariant) {
        const parentVariantId = findParentVariantIdForComponentVariant(componentVariant);
        if (!parentVariantId) return false;
        const parentVariant = getParentVariantById(parentVariantId);
        if (!parentVariant) return false;
        return commitParentVariantSelection(parentVariant);
      }

      function reconcileParentVariantWithLocalSizeConstraints() {
        const localSizeConstraints = selectedLocalComponentSizeConstraints();
        if (!localSizeConstraints.length) return false;
        const currentInputVariant = getNativeSelectedParentVariant() || getParentVariantById(getCurrentParentVariantId());
        const expectedSize = selectedGlobalSizeValue() || selectedVariantSizeValue() || (currentInputVariant ? currentInputVariant.size : '');
        const expectedColor = activeVariantSyncedSwatchColor() || (currentInputVariant ? currentInputVariant.color : '');
        const parentVariantId = findParentVariantIdBySizePreservingOptions(expectedSize, currentInputVariant, expectedColor, localSizeConstraints)
          || findParentVariantIdBySizeColorAndLocalConstraints(expectedSize, expectedColor, localSizeConstraints)
          || findParentVariantIdBySizeColorAndLocalConstraints(expectedSize, '', localSizeConstraints)
          || findParentVariantIdBySizeColorAndLocalConstraints('', expectedColor, localSizeConstraints)
          || findParentVariantIdBySizeColorAndLocalConstraints('', '', localSizeConstraints);
        if (!parentVariantId) return false;
        const parentVariant = getParentVariantById(parentVariantId);
        if (!parentVariant) return false;
        return commitParentVariantSelection(parentVariant);
      }

      function resolveCurrentParentVariantId() {
        const variantMap = getParentVariantMap();
        const localSizeConstraints = selectedLocalComponentSizeConstraints();
        const requestedGlobalSize = selectedRequestedGlobalSizeValue();
        if (requestedGlobalSize) {
          const stickyForRequest = String(bundleUiRuntime.lastUserSelectedParentVariantId || '').trim();
          const currentForRequest = (stickyForRequest && variantMap[stickyForRequest] ? variantMap[stickyForRequest] : null)
            || getNativeSelectedParentVariant();
          const requestedColor = activeVariantSyncedSwatchColor() || (currentForRequest ? currentForRequest.color : '');
          const requestedVariantId = findParentVariantIdBySizePreservingOptions(requestedGlobalSize, currentForRequest, requestedColor, localSizeConstraints)
            || findParentVariantIdBySizeColorAndLocalConstraints(requestedGlobalSize, requestedColor, localSizeConstraints)
            || findParentVariantIdBySizeColorAndLocalConstraints(requestedGlobalSize, '', localSizeConstraints);
          if (requestedVariantId) return requestedVariantId;
        }
        const stickyUserChoice = String(bundleUiRuntime.lastUserSelectedParentVariantId || '').trim();
        if (stickyUserChoice && variantMap[stickyUserChoice] && parentVariantMatchesLocalSizeConstraints(variantMap[stickyUserChoice], localSizeConstraints)) return stickyUserChoice;

        const activeSwatchParentVariantId = activeVariantSyncedSwatchParentVariantId();
        if (activeSwatchParentVariantId && variantMap[activeSwatchParentVariantId] && parentVariantMatchesLocalSizeConstraints(variantMap[activeSwatchParentVariantId], localSizeConstraints)) return activeSwatchParentVariantId;

        const activeSwatchColor = activeVariantSyncedSwatchColor();
        if (activeSwatchColor) {
          const contextInputId = getCurrentParentVariantId();
          const contextInputVariant = contextInputId && variantMap[contextInputId] ? variantMap[contextInputId] : null;
          const activeSwatchSize = selectedGlobalSizeValue() || selectedVariantSizeValue() || (contextInputVariant ? contextInputVariant.size : '');
          const byActiveSwatchColor = findParentVariantIdBySizeColorAndLocalConstraints(activeSwatchSize, activeSwatchColor, localSizeConstraints)
            || findParentVariantIdBySizeColorAndLocalConstraints('', activeSwatchColor, localSizeConstraints);
          if (byActiveSwatchColor && variantMap[byActiveSwatchColor] && parentVariantMatchesLocalSizeConstraints(variantMap[byActiveSwatchColor], localSizeConstraints)) return byActiveSwatchColor;
        }

        const byCheckedOptions = parentVariantIdByOptionValueIds(optionValueIdsFromVariantInputs());
        if (byCheckedOptions && parentVariantMatchesLocalSizeConstraints(variantMap[byCheckedOptions], localSizeConstraints)) return byCheckedOptions;

        const inputId = getCurrentParentVariantId();
        if (inputId && variantMap[inputId] && parentVariantMatchesLocalSizeConstraints(variantMap[inputId], localSizeConstraints)) return inputId;

        const byQueryString = parentVariantIdByOptionValueIds(optionValueIdsFromQueryString());
        if (byQueryString && parentVariantMatchesLocalSizeConstraints(variantMap[byQueryString], localSizeConstraints)) return byQueryString;

        const current = bundleUiRuntime.lastRenderedVariantId && variantMap[bundleUiRuntime.lastRenderedVariantId]
          ? variantMap[bundleUiRuntime.lastRenderedVariantId]
          : null;
        const fallbackSize = selectedGlobalSizeValue() || selectedVariantSizeValue() || (current ? current.size : '');
        const fallbackColor = activeVariantSyncedSwatchColor() || (current ? current.color : '');
        return findParentVariantIdBySizeColorAndLocalConstraints(fallbackSize, fallbackColor, localSizeConstraints)
          || findParentVariantIdBySizeColorAndLocalConstraints(fallbackSize, '', localSizeConstraints)
          || (!localSizeConstraints.length ? findParentVariantIdBySize(fallbackSize, fallbackColor) : '');
      }

      function syncGlobalSizeSelectorFromParentVariant(parentVariant) {
        if (!SHOW_GLOBAL_SIZE_SELECTOR) return;
        const select = document.querySelector('[data-mdl-bundle-global-size-select]');
        if (!select || !parentVariant) return;
        const targetSize = String(parentVariant.size || '').trim();
        if (!targetSize) return;
        if (String(select.value || '').trim() === targetSize) return;
        const match = Array.from(select.options).find((option) => String(option.value || '').trim() === targetSize);
        if (!match) return;
        select.value = targetSize;
      }

      function syncGlobalSizeOptionAvailability(parentVariant) {
        if (!SHOW_GLOBAL_SIZE_SELECTOR || !IS_ONEA_PARURE) return;
        const select = document.querySelector('[data-mdl-bundle-global-size-select]');
        if (!select || !parentVariant) return;
        const activeColor = normalizeColorValue(parentVariant.color);
        if (!activeColor) return;
        const availableSizes = new Set();
        Object.values(getParentVariantMap()).forEach((variant) => {
          if (!variant || variant.available === false) return;
          if (normalizeColorValue(variant.color) !== activeColor) return;
          const size = String(variant.size || '').trim();
          if (size) availableSizes.add(size);
        });
        if (!availableSizes.size) return;
        const currentSize = String(parentVariant.size || select.value || '').trim();
        Array.from(select.options).forEach((option) => {
          const size = String(option.value || '').trim();
          if (!size) return;
          option.disabled = size !== currentSize && !availableSizes.has(size);
        });
      }

      function getCurrentParentVariant() {
        const resolvedId = resolveCurrentParentVariantId();
        return resolvedId ? (getParentVariantMap()[resolvedId] || null) : null;
      }

      function getCurrentRuntimeParentVariant() {
        const resolvedId = resolveCurrentParentVariantId();
        if (!resolvedId) return null;
        return storefrontRuntime.parentMap && storefrontRuntime.parentMap[resolvedId]
          ? storefrontRuntime.parentMap[resolvedId]
          : null;
      }

      function getParentVariantById(variantId) {
        const id = String(variantId || '');
        if (!id) return null;
        return getParentVariantMap()[id] || null;
      }

      function syncNativeVariantOptionInputs(parentVariant, options) {
        if (!parentVariant || !Array.isArray(parentVariant.option_value_ids)) return;
        const shouldNotify = options?.notify === true || (!CONFIGURABLE_PACK_OPTIONS && options?.notify !== false);
        const expected = new Set(parentVariant.option_value_ids.map((valueId) => String(valueId || '')).filter(Boolean));
        if (!expected.size) return;
        window.__mdlBundleNativeOptionSyncing = true;
        const changedInputs = [];
        try {
          document.querySelectorAll('variant-selector input[name^="option"]').forEach((input) => {
            const inputValue = String(input.value || '');
            const shouldCheck = expected.has(inputValue);
            const wasChecked = Boolean(input.checked);
            input.checked = shouldCheck;
            if (wasChecked !== shouldCheck) changedInputs.push(input);
          });
          const inputsToNotify = shouldNotify ? (IS_ONEA_PARURE ? changedInputs.slice(-1) : changedInputs) : [];
          inputsToNotify.forEach((input) => {
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        } finally {
          window.setTimeout(() => {
            window.__mdlBundleNativeOptionSyncing = false;
          }, 0);
        }
      }

      function syncParentVariantIdInputs(parentVariant) {
        if (!parentVariant || !parentVariant.id) return;
        const targetId = String(parentVariant.id).trim();
        if (!targetId) return;
        document.querySelectorAll('form[action*="/cart/add"] input[name="id"], input[name="id"]').forEach((input) => {
          if (String(input.value || '').trim() === targetId) return;
          input.value = targetId;
        });
      }

      function syncParentVariantUrl(parentVariant) {
        if (!parentVariant || !Array.isArray(parentVariant.option_value_ids) || !parentVariant.option_value_ids.length) return;
        const optionValues = parentVariant.option_value_ids.filter(Boolean).join(',');
        if (!optionValues) return;
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('option_values', optionValues);
          url.searchParams.delete('variant');
          window.history.replaceState({}, '', url.toString());
        } catch (error) {}
      }

      function commitParentVariantSelection(parentVariant) {
        if (!parentVariant || !parentVariant.id) return false;
        const nextVariantId = String(parentVariant.id).trim();
        if (!nextVariantId) return false;
        bundleUiRuntime.lastUserSelectedParentVariantId = nextVariantId;
        syncBundlePriceDisplay((storefrontRuntime.parentMap || {})[nextVariantId] || null);
        syncNativeVariantOptionInputs(parentVariant);
        syncConfigurablePackControlsFromParentVariant(parentVariant);
        syncParentVariantIdInputs(parentVariant);
        syncParentVariantUrl(parentVariant);
        if (!IS_ONEA_PARURE && !CONFIGURABLE_PACK_OPTIONS) {
          const idInputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"], input[name="id"]');
          idInputs.forEach((input) => {
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
        window.dispatchEvent(new CustomEvent('mdl:bundle-parent-variant-sync', { detail: { variantId: nextVariantId } }));
        return true;
      }

      function collectParentBundleComponentsPayload() {
        const cards = Array.from(document.querySelectorAll('[data-mdl-bundle-item]'));
        const components = cards.map((card) => {
          const key = String(card.dataset.mdlComponentKey || '').trim();
          const localSelection = key ? bundleUiRuntime.componentSelections[key] : null;
          const titleNode = card.querySelector('.mdl-bundle-item__name');
          const variantNode = card.querySelector('.mdl-bundle-item__size');
          const quantity = Number(card.dataset.mdlBundleQuantity || '1');
          return {
            title: titleNode ? titleNode.textContent.trim() : '',
            variant: localSelection && localSelection.variantTitle ? localSelection.variantTitle : (variantNode ? variantNode.textContent.trim() : ''),
            variant_id: localSelection && localSelection.variantId ? String(localSelection.variantId) : String(card.dataset.mdlBundleVariantId || ''),
            quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1
          };
        }).filter((component) => component.title);
        return components;
      }

      function optionValueByName(selectedOptions, nameHint) {
        const list = Array.isArray(selectedOptions) ? selectedOptions : [];
        const hint = String(nameHint || '').trim().toLowerCase();
        if (!hint) return '';
        const exact = list.find((option) => String(option.name || '').trim().toLowerCase() === hint);
        if (exact) return exact.value || '';
        const contains = list.find((option) => String(option.name || '').trim().toLowerCase().includes(hint));
        return contains ? (contains.value || '') : '';
      }

      function findParentVariantIdBySizeAndColor(size, color) {
        const expectedSize = String(size || '').trim();
        const expectedColor = normalizeColorValue(color);
        if (!expectedSize || !expectedColor) return '';
        const entries = Object.entries(getParentVariantMap());
        for (const [variantId, variant] of entries) {
          if (!variant) continue;
          if (String(variant.size || '').trim() !== expectedSize) continue;
          if (normalizeColorValue(variant.color) !== expectedColor) continue;
          return variantId;
        }
        return '';
      }

      function syncBundleColorSelector(parentVariant) {
        if (!IS_ONEA_PARURE) return;
        const selectedColor = normalizeColorValue(parentVariant && parentVariant.color);
        document.querySelectorAll('[data-mdl-bundle-color-option]').forEach((option) => {
          const isActive = normalizeColorValue(option.dataset.mdlBundleColorValue) === selectedColor;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function handleBundleColorOption(option) {
        if (!IS_ONEA_PARURE || !option) return false;
        const requestedColor = String(option.dataset.mdlBundleColorValue || '').trim();
        if (!requestedColor) return false;
        const currentVariant = getCurrentParentVariant();
        const requestedSize = selectedGlobalSizeValue() || (currentVariant ? currentVariant.size : '');
        const nextVariantId = findParentVariantIdBySizeColorAndLocalConstraints(requestedSize, requestedColor, []);
        const nextParentVariant = nextVariantId ? getParentVariantById(nextVariantId) : null;
        if (!nextParentVariant) return false;
        bundleUiRuntime.lastUserSelectedParentVariantId = String(nextParentVariant.id || '');
        commitParentVariantSelection(nextParentVariant);
        syncBundleColorSelector(nextParentVariant);
        syncGlobalSizeOptionAvailability(nextParentVariant);
        syncNativeBundleAtcState();
        reinforceGlobalSizeSelection(nextParentVariant, requestedSize, requestedColor);
        return true;
      }

      function normalizeListMatcher(items) {
        return Array.isArray(items)
          ? items.map((item) => String(item || '').trim().toLowerCase()).filter(Boolean)
          : [];
      }

      function componentMatchesList(component, list) {
        const normalized = normalizeListMatcher(list);
        if (!normalized.length) return false;
        const type = String((component && component.productType) || '').trim().toLowerCase();
        const title = String((component && component.productTitle) || '').trim().toLowerCase();
        const handle = String((component && component.productHandle) || '').trim().toLowerCase();
        return normalized.some((token) => {
          return handle.includes(token) || type.includes(token) || title.includes(token);
        });
      }

      function componentKey(component, index) {
        return `${String((component && component.productHandle) || 'component')}::${Number(index || 0)}`;
      }

      function componentSelectedVariantId(component, index) {
        const key = componentKey(component, index);
        const selected = bundleUiRuntime.componentSelections[key];
        return String((selected && selected.variantId) || component.variantId || '').trim();
      }

      function componentVariantsForHandle(component) {
        const handle = String((component && component.productHandle) || '').trim();
        const variants = storefrontRuntime.syncedHandleVariants[handle] || [];
        return Array.isArray(variants) ? variants : [];
      }

      function variantSizeValue(variant) {
        if (!variant) return '';
        return optionValueByName(variant.selectedOptions, SIZE_OPTION_NAME)
          || optionValueByName(variant.selectedOptions, 'taille')
          || ((variant.selectedOptions || [])[0] || {}).value
          || '';
      }

      function variantColorValue(variant) {
        if (!variant) return '';
        return optionValueByName(variant.selectedOptions, PARENT_COLOR_OPTION_NAME)
          || optionValueByName(variant.selectedOptions, 'couleur')
          || '';
      }

      function variantHeightValue(variant) {
        if (!variant) return '';
        return optionValueByName(variant.selectedOptions, 'hauteur') || '';
      }

      function optionSwatchByName(selectedOptions, optionNameHint) {
        const list = Array.isArray(selectedOptions) ? selectedOptions : [];
        const hint = String(optionNameHint || '').trim().toLowerCase();
        if (!hint) return null;
        const exact = list.find((option) => String((option && option.name) || '').trim().toLowerCase() === hint);
        if (exact && exact.optionValue && exact.optionValue.swatch) return exact.optionValue.swatch;
        const contains = list.find((option) => String((option && option.name) || '').trim().toLowerCase().includes(hint));
        if (contains && contains.optionValue && contains.optionValue.swatch) return contains.optionValue.swatch;
        return null;
      }

      function variantColorSwatch(variant) {
        if (!variant) return null;
        if (variant.nativeSwatch) return variant.nativeSwatch;
        return optionSwatchByName(variant.selectedOptions, PARENT_COLOR_OPTION_NAME)
          || optionSwatchByName(variant.selectedOptions, 'couleur')
          || null;
      }

      function colorValueToHex(colorValue) {
        const key = String(colorValue || '').trim().toLowerCase();
        const map = {
          beige: '#d8c3a5',
          gris: '#8a8f98',
          'gris foncé': '#655c5f',
          'gris fonce': '#655c5f',
          anthracite: '#655c5f',
          marron: '#5b4636',
          brown: '#5b4636',
          taupe: '#8b7d6b',
          noir: '#1f1f1f',
          blanc: '#f4f4f4',
        };
        return map[key] || '';
      }

      function configurablePackComponentKind(component) {
        if (!CONFIGURABLE_PACK_OPTIONS) return '';
        const identity = [component?.productHandle, component?.productType, component?.productTitle]
          .map((value) => normalizeParentVariantOptionValue(value))
          .join(' ');
        if (identity.includes('oreiller')) return 'pillow';
        if (identity.includes('couette')) return 'duvet';
        return '';
      }

      function configurablePackChoiceValues(kind) {
        const values = [];
        Object.values(getParentVariantMap()).forEach((variant) => {
          const options = Array.isArray(variant?.options) ? variant.options : [];
          const value = kind === 'duvet'
            ? String(options[1] || '').trim()
            : configurablePackOptionParts(options[2]).firmness;
          if (!value || values.some((entry) => normalizeParentVariantOptionValue(entry) === normalizeParentVariantOptionValue(value))) return;
          values.push(value);
        });
        return values;
      }

      function renderConfigurablePackCardChoice(component, parentVariant, index) {
        const kind = configurablePackComponentKind(component);
        if (!kind) return '';
        const values = configurablePackChoiceValues(kind);
        if (values.length < 2) return '';
        const parentOptions = Array.isArray(parentVariant?.options) ? parentVariant.options : [];
        const selectedValue = kind === 'duvet'
          ? String(parentOptions[1] || '').trim()
          : configurablePackOptionParts(parentOptions[2]).firmness;
        const label = kind === 'duvet' ? 'Chaleur' : 'Fermeté';
        const selectId = `mdl-pack-card-${kind}-${index}`;
        const dataAttribute = kind === 'duvet' ? 'data-mdl-pack-card-heat-select' : 'data-mdl-pack-card-firmness-select';
        const choices = values.map((value) => {
          const selected = normalizeParentVariantOptionValue(value) === normalizeParentVariantOptionValue(selectedValue);
          return `<option value="${escapeHtml(value)}"${selected ? ' selected' : ''}>${escapeHtml(value)}</option>`;
        }).join('');
        return `<span class="mdl-bundle-item__pack-choice" data-mdl-pack-card-choice="${kind}" role="group" aria-label="${escapeHtml(label)}"><label class="mdl-bundle-item__pack-choice-label" for="${escapeHtml(selectId)}">${escapeHtml(label)}</label><span class="mdl-bundle-item__pack-choice-options"><select id="${escapeHtml(selectId)}" ${dataAttribute} aria-label="${escapeHtml(label)}">${choices}</select></span></span>`;
      }

      function renderBundleComponentCard(component, parentVariant, index) {
        const listNode = document.querySelector('[data-mdl-bundle-runtime-list]');
        if (!listNode) return '';
        const modalId = `mdl-bundle-modal-${component.productHandle || 'component'}-${index}`;
        const itemImage = component.variantImage || component.productFeaturedImage || '';
        const itemTitle = component.productTitle || component.productHandle || 'Produit';
        const isIndependentSize = componentMatchesList(component, INDEPENDENT_SIZE_COMPONENTS);
        const hasLocalColorSwatches = componentMatchesList(component, COLOR_SWATCH_COMPONENTS);
        const localVariants = componentVariantsForHandle(component);
        const selectedVariantId = componentSelectedVariantId(component, index);
        let selectedLocalVariant = localVariants.find((variant) => String(variant.id) === selectedVariantId)
          || localVariants.find((variant) => String(variant.id) === String(component.variantId))
          || null;
        if (selectedLocalVariant && !isIndependentSize && parentVariant) {
          const selectedSize = String(variantSizeValue(selectedLocalVariant)).trim();
          const parentSize = String(parentVariant.size || '').trim();
          if (selectedSize && parentSize && selectedSize !== parentSize) {
            const selectedColor = String(variantColorValue(selectedLocalVariant)).trim();
            selectedLocalVariant = localVariants.find((variant) => {
              return String(variantSizeValue(variant)).trim() === parentSize
                && (!selectedColor || String(variantColorValue(variant)).trim() === selectedColor);
            }) || null;
            if (selectedLocalVariant) {
              setComponentSelection(componentKey(component, index), selectedLocalVariant);
            }
          }
        }
        const selectedSourceVariant = selectedLocalVariant || {
          id: component.variantId,
          title: component.variantTitle,
          image: component.variantImage || component.productFeaturedImage || '',
          selectedOptions: component.selectedOptions || [],
          available: component.variantAvailable !== false,
        };
        const itemVariantTitle = selectedSourceVariant.title || component.variantTitle || '';
        const itemUrl = component.productUrl || '#';
        const configurablePackChoiceHtml = renderConfigurablePackCardChoice(component, parentVariant, index);
        const hasCardChoices = Boolean(configurablePackChoiceHtml);
        const cardAttr = [
          `class="mdl-bundle-item"`,
          ...(hasCardChoices ? [] : [`role="button"`, `tabindex="0"`]),
          `data-mdl-bundle-item`,
          `data-mdl-bundle-role="${SYNCED_COMPONENT_HANDLES.includes(component.productHandle) ? 'variant-synced' : 'component'}"`,
          `data-mdl-bundle-variant-id="${escapeHtml(selectedSourceVariant.id || component.variantId)}"`,
          `data-mdl-bundle-quantity="${Number(component.quantity || 1)}"`,
          `data-mdl-component-key="${escapeHtml(componentKey(component, index))}"`,
          `data-mdl-bundle-item-title="${escapeHtml(itemTitle)}"`,
          `data-mdl-bundle-modal-target="${escapeHtml(modalId)}"`,
          ...(hasCardChoices ? [] : [`data-mdl-bundle-modal-trigger="true"`, `aria-haspopup="dialog"`]),
        ].join(' ');
        const modalTriggerHtml = hasCardChoices
          ? `<button type="button" class="mdl-bundle-item__modal-trigger" data-mdl-bundle-modal-trigger="true" data-mdl-bundle-modal-target="${escapeHtml(modalId)}" aria-haspopup="dialog" aria-label="${escapeHtml(VIEW_PRODUCT_TEXT)}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`
          : `<span class="mdl-bundle-item__chevron" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`;

        let swatchesHtml = '';
        let localSizeHtml = '';
        if (isIndependentSize && localVariants.length) {
          const uniqueSizes = Array.from(new Set(localVariants.map((variant) => String(variantSizeValue(variant)).trim()).filter(Boolean)));
          if (uniqueSizes.length) {
            const selectedSize = String(variantSizeValue(selectedSourceVariant)).trim();
            localSizeHtml = `<label class="mdl-bundle-item__local-size"><span>Taille</span><select data-mdl-component-size-select data-mdl-component-key="${escapeHtml(componentKey(component, index))}">${uniqueSizes.map((size) => `<option value="${escapeHtml(size)}"${size === selectedSize ? ' selected' : ''}>${escapeHtml(size)}</option>`).join('')}</select></label>`;
          }
        }
        const parentSwatchEligible = SHOW_SYNCED_SWATCHES && SYNCED_COMPONENT_HANDLES.includes(component.productHandle);
        const hasRealColorVariants = (() => {
          const colorValues = new Set(
            localVariants
              .map((variant) => String(variantColorValue(variant)).trim())
              .filter(Boolean)
          );
          return colorValues.size > 1;
        })();
        const prefersLocalComponentSwatches = hasLocalColorSwatches && hasRealColorVariants && !parentSwatchEligible;
        const swatchMode = parentSwatchEligible && hasRealColorVariants
          ? 'parent'
          : (prefersLocalComponentSwatches ? 'component' : 'none');
        if (swatchMode !== 'none') {
          const syncedVariants = storefrontRuntime.syncedHandleVariants[component.productHandle] || [];
          const parentSize = parentVariant ? parentVariant.size : '';
          const matchingVariants = syncedVariants.filter((variant) => {
            if (isIndependentSize) return true;
            const size = variantSizeValue(variant);
            return String(size).trim() === String(parentSize).trim();
          });
          const selectedSomflexHeight = variantHeightValue(selectedSourceVariant)
            || selectedLocalComponentSizeConstraints().find((value) => /\b\d+(?:[.,]\d+)?\s*cm\b/i.test(value))
            || '';
          const swatchParentSizeConstraints = selectedLocalComponentSizeConstraints()
            .filter((value) => !/^\d+(?:[.,]\d+)?\s*cm$/i.test(value));
          if (selectedSomflexHeight) swatchParentSizeConstraints.push(selectedSomflexHeight);
          const variantsByColor = new Map();
          matchingVariants.forEach((variant) => {
            const colorKey = normalizeColorValue(variantColorValue(variant));
            if (!colorKey) return;
            const current = variantsByColor.get(colorKey);
            const matchesHeight = selectedSomflexHeight && variantHeightValue(variant) === selectedSomflexHeight;
            const currentMatchesHeight = current && selectedSomflexHeight && variantHeightValue(current) === selectedSomflexHeight;
            if (!current || (matchesHeight && !currentMatchesHeight)) {
              variantsByColor.set(colorKey, variant);
            }
          });
          const swatchVariants = Array.from(variantsByColor.values());
          if (swatchVariants.length) {
            swatchesHtml += `<span class="mdl-bundle-item__swatches" data-mdl-variant-synced-swatches data-mdl-swatch-mode="${swatchMode}" data-parent-color-option-position="${PARENT_COLOR_OPTION_POSITION}" data-selected-handle="" data-selected-image="${escapeHtml(itemImage)}" data-selected-modal-image="${escapeHtml(itemImage)}">`;
            for (const variant of swatchVariants) {
              const swatchColor = variantColorValue(variant);
              const nativeSwatch = variantColorSwatch(variant);
              const nativeSwatchImage = (() => {
                if (!nativeSwatch || !nativeSwatch.image) return '';
                if (nativeSwatch.image.image && nativeSwatch.image.image.url) return nativeSwatch.image.image.url;
                if (nativeSwatch.image.url) return nativeSwatch.image.url;
                return '';
              })();
              const swatchImage = nativeSwatchImage || variant.image || itemImage;
              const swatchHex = (nativeSwatch && nativeSwatch.color) || colorValueToHex(swatchColor);
              const isActive = String(variant.id) === String(selectedSourceVariant.id || component.variantId);
              const parentVariantId = findParentVariantIdBySizeColorAndLocalConstraints(parentSize, swatchColor, swatchParentSizeConstraints);
              const localAttr = swatchMode === 'component' ? ' data-mdl-component-swatch="true"' : '';
              const swatchInnerHtml = swatchHex
                ? `<span class="mdl-bundle-swatch__dot" style="--mdl-swatch-color:${escapeHtml(swatchHex)}"></span>`
                : `<img src="${escapeHtml(swatchImage)}" alt="${escapeHtml(variant.title)}" loading="lazy">`;
              swatchesHtml += `<span role="button" tabindex="0" class="mdl-bundle-swatch${isActive ? ' is-active' : ''}" data-mdl-swatch data-swatch-available="${variant.available}" data-swatch-handle="${escapeHtml(swatchColor)}" data-swatch-image="${escapeHtml(swatchImage)}" data-swatch-modal-image="${escapeHtml(swatchImage)}" data-swatch-color="${escapeHtml(swatchHex)}" data-swatch-variant-id="${escapeHtml(variant.id)}" data-swatch-parent-variant-id="${escapeHtml(parentVariantId)}" data-swatch-label="${escapeHtml(variant.title)}" data-mdl-component-key="${escapeHtml(componentKey(component, index))}"${localAttr} aria-label="${escapeHtml(variant.title)}" aria-pressed="${isActive ? 'true' : 'false'}">${swatchInnerHtml}</span>`;
            }
            swatchesHtml += `</span>`;
          }
        }

        return `
          <div ${cardAttr}>
            <span class="mdl-bundle-item__image">${itemImage ? `<img data-mdl-bundle-thumb src="${escapeHtml(itemImage)}" alt="${escapeHtml(itemTitle)}" loading="lazy">` : ''}</span>
            <span class="mdl-bundle-item__content">
              <span class="mdl-bundle-item__name">${escapeHtml(itemTitle)}</span>
              <span class="mdl-bundle-item__size">${escapeHtml(itemVariantTitle)}</span>
              ${configurablePackChoiceHtml}
              ${localSizeHtml}
              ${swatchesHtml}
            </span>
            ${modalTriggerHtml}
          </div>
          <dialog class="mdl-bundle-modal" id="${escapeHtml(modalId)}">
            <div class="mdl-bundle-modal__inner">
              <div class="mdl-bundle-modal__image">${itemImage ? `<img data-mdl-bundle-modal-image src="${escapeHtml(itemImage)}" alt="${escapeHtml(itemTitle)}" loading="lazy">` : ''}</div>
              <div class="mdl-bundle-modal__content">
                <div class="mdl-bundle-modal__header">
                  <h3 class="mdl-bundle-modal__title">${escapeHtml(itemTitle)}</h3>
                  <button type="button" class="mdl-bundle-modal__close" data-mdl-bundle-modal-close aria-label="Fermer">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
                  </button>
                </div>
                <p class="mdl-bundle-item__size">${escapeHtml(SIZE_LABEL_TEXT)} ${escapeHtml(itemVariantTitle)}</p>
                ${component.productDescriptionHtml ? `<div class="mdl-bundle-modal__description">${component.productDescriptionHtml}</div>` : ''}
                ${itemUrl && itemUrl !== '#' ? `<a class="mdl-bundle-modal__link" href="${escapeHtml(itemUrl)}">${escapeHtml(VIEW_PRODUCT_TEXT)}</a>` : ''}
              </div>
            </div>
          </dialog>
        `;
      }

      function componentTypeRank(component) {
        const productType = String((component && component.productType) || '').trim().toLowerCase();
        if (!productType) return 999;
        if (productType.includes('matelas')) return 10;
        if (productType.includes('sommier')) return 20;
        if (productType.includes('pied')) return 30;
        if (productType.includes('couette')) return 40;
        if (productType.includes('oreiller')) return 50;
        return 999;
      }

      function sortBundleComponents(components) {
        const list = Array.isArray(components) ? components.slice() : [];
        const configuredOrder = Array.isArray(PACK_COMPONENTS_ORDER)
          ? PACK_COMPONENTS_ORDER.map((item) => String(item || '').trim().toLowerCase()).filter(Boolean)
          : [];
        const hasConfiguredOrder = configuredOrder.length > 0;
        const configuredRank = new Map();
        if (hasConfiguredOrder) {
          configuredOrder.forEach((label, index) => {
            if (!configuredRank.has(label)) configuredRank.set(label, index);
          });
        }
        function componentConfiguredRank(component) {
          if (!hasConfiguredOrder) return 9999;
          const productType = String((component && component.productType) || '').trim().toLowerCase();
          const title = String((component && component.productTitle) || '').trim().toLowerCase();
          const handle = String((component && component.productHandle) || '').trim().toLowerCase();
          let best = 9999;
          configuredRank.forEach((idx, label) => {
            if (productType === label || title.includes(label) || handle.includes(label)) {
              if (idx < best) best = idx;
            }
          });
          return best;
        }
        return list.sort((a, b) => {
          const configuredDiff = componentConfiguredRank(a) - componentConfiguredRank(b);
          if (configuredDiff !== 0) return configuredDiff;
          const rankDiff = componentTypeRank(a) - componentTypeRank(b);
          if (rankDiff !== 0) return rankDiff;
          return 0;
        });
      }

      function syncElementAttributes(current, next) {
        Array.from(current.attributes).forEach((attribute) => {
          if (!next.hasAttribute(attribute.name)) current.removeAttribute(attribute.name);
        });
        Array.from(next.attributes).forEach((attribute) => {
          if (current.getAttribute(attribute.name) !== attribute.value) current.setAttribute(attribute.name, attribute.value);
        });
      }

      function syncConfigurablePackChoiceGroup(currentCard, nextCard, kind) {
        const selector = `[data-mdl-pack-card-choice="${kind}"]`;
        const currentGroup = currentCard.querySelector(selector);
        const nextGroup = nextCard.querySelector(selector);
        if (!currentGroup && !nextGroup) return;
        if (!currentGroup && nextGroup) {
          const sizeNode = currentCard.querySelector('.mdl-bundle-item__size');
          if (sizeNode) sizeNode.insertAdjacentElement('afterend', nextGroup.cloneNode(true));
          return;
        }
        if (currentGroup && !nextGroup) {
          currentGroup.remove();
          return;
        }
        syncElementAttributes(currentGroup, nextGroup);
        const currentSelect = currentGroup.querySelector('select');
        const nextSelect = nextGroup.querySelector('select');
        if (currentSelect && nextSelect) {
          syncElementAttributes(currentSelect, nextSelect);
          const currentOptions = Array.from(currentSelect.options);
          const nextOptions = Array.from(nextSelect.options);
          const sameValues = currentOptions.length === nextOptions.length
            && currentOptions.every((option, index) => option.value === nextOptions[index].value);
          if (!sameValues) {
            currentGroup.replaceWith(nextGroup.cloneNode(true));
            return;
          }
          currentOptions.forEach((option, index) => {
            const nextOption = nextOptions[index];
            syncElementAttributes(option, nextOption);
            option.disabled = nextOption.disabled;
            option.selected = nextOption.selected;
          });
          currentSelect.value = nextSelect.value;
          return;
        }
        const nextInputs = new Map(Array.from(nextGroup.querySelectorAll('input')).map((input) => [input.value, input]));
        const currentInputs = Array.from(currentGroup.querySelectorAll('input'));
        const sameValues = currentInputs.length === nextInputs.size && currentInputs.every((input) => nextInputs.has(input.value));
        if (!sameValues) {
          currentGroup.replaceWith(nextGroup.cloneNode(true));
          return;
        }
        currentInputs.forEach((input) => {
          const nextInput = nextInputs.get(input.value);
          syncElementAttributes(input, nextInput);
          input.checked = nextInput.checked;
          input.disabled = nextInput.disabled;
          const label = input.closest('label');
          const nextLabel = nextInput.closest('label');
          if (label && nextLabel) syncElementAttributes(label, nextLabel);
        });
      }

      function reconcileConfigurablePackList(listNode, nextContent) {
        if (!CONFIGURABLE_PACK_OPTIONS) return false;
        const currentCards = Array.from(listNode.children).filter((node) => node.matches('[data-mdl-bundle-item]'));
        const nextCards = Array.from(nextContent.children).filter((node) => node.matches('[data-mdl-bundle-item]'));
        const currentModals = Array.from(listNode.children).filter((node) => node.matches('dialog.mdl-bundle-modal'));
        const nextModals = Array.from(nextContent.children).filter((node) => node.matches('dialog.mdl-bundle-modal'));
        if (!currentCards.length || currentCards.length !== nextCards.length || currentModals.length !== nextModals.length) return false;
        currentCards.forEach((currentCard, index) => {
          const nextCard = nextCards[index];
          syncElementAttributes(currentCard, nextCard);
          ['.mdl-bundle-item__name', '.mdl-bundle-item__size'].forEach((selector) => {
            const currentNode = currentCard.querySelector(selector);
            const nextNode = nextCard.querySelector(selector);
            if (currentNode && nextNode && currentNode.textContent !== nextNode.textContent) currentNode.textContent = nextNode.textContent;
          });
          const currentImage = currentCard.querySelector('[data-mdl-bundle-thumb]');
          const nextImage = nextCard.querySelector('[data-mdl-bundle-thumb]');
          if (currentImage && nextImage) syncElementAttributes(currentImage, nextImage);
          syncConfigurablePackChoiceGroup(currentCard, nextCard, 'duvet');
          syncConfigurablePackChoiceGroup(currentCard, nextCard, 'pillow');
        });
        currentModals.forEach((currentModal, index) => {
          const nextModal = nextModals[index];
          if (currentModal.open) return;
          syncElementAttributes(currentModal, nextModal);
          const currentImage = currentModal.querySelector('[data-mdl-bundle-modal-image]');
          const nextImage = nextModal.querySelector('[data-mdl-bundle-modal-image]');
          if (currentImage && nextImage) syncElementAttributes(currentImage, nextImage);
          ['.mdl-bundle-modal__title', '.mdl-bundle-modal__content > .mdl-bundle-item__size'].forEach((selector) => {
            const currentNode = currentModal.querySelector(selector);
            const nextNode = nextModal.querySelector(selector);
            if (currentNode && nextNode && currentNode.textContent !== nextNode.textContent) currentNode.textContent = nextNode.textContent;
          });
        });
        return true;
      }

      async function renderRuntimeBundleComponents() {
        const listNode = document.querySelector('[data-mdl-bundle-runtime-list]');
        if (!listNode) return false;
        const parentVariantId = resolveCurrentParentVariantId();
        const parentVariant = parentVariantId ? storefrontRuntime.parentMap[parentVariantId] : null;
        const runtimeComponents = parentVariant && Array.isArray(parentVariant.components) ? parentVariant.components : [];
        const components = sortBundleComponents(runtimeComponents);
        const hasExistingItems = listNode.querySelectorAll('[data-mdl-bundle-item]').length > 0;
        if (!components.length && hasExistingItems) {
          listNode.dataset.mdlHasItems = 'true';
          return false;
        }
        const nextHtml = components.map((component, index) => renderBundleComponentCard(component, parentVariant, index + 1)).join('');
        if (nextHtml === listNode.innerHTML) {
          listNode.dataset.mdlHasItems = components.length ? 'true' : 'false';
          syncBundleListHeightGuard();
          return true;
        }
        const currentHeight = listNode.offsetHeight;
        if (currentHeight > 0) {
          listNode.style.minHeight = `${Math.max(currentHeight, 96)}px`;
          listNode.dataset.mdlReplacing = 'true';
        }
        const template = document.createElement('template');
        template.innerHTML = nextHtml;
        if (reconcileConfigurablePackList(listNode, template.content)) {
          listNode.style.minHeight = '';
          delete listNode.dataset.mdlReplacing;
          listNode.dataset.mdlHasItems = components.length ? 'true' : 'false';
          syncBundleListHeightGuard();
          return true;
        }
        listNode.replaceChildren(...Array.from(template.content.childNodes));
        listNode.dataset.mdlHasItems = components.length ? 'true' : 'false';
        syncBundleListHeightGuard();
        if (currentHeight > 0) {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              listNode.style.minHeight = '';
              delete listNode.dataset.mdlReplacing;
              syncBundleListHeightGuard();
            });
          });
        }
        return true;
      }

      async function ensureAndRenderRuntimeBundleComponents() {
        try {
          await ensureRuntimeBundleData();
          const rendered = await renderRuntimeBundleComponents();
          syncBundleSyncedSwatchAvailability();
          syncConfigurablePackChoiceAvailability();
          return rendered;
        } catch (error) {
          setNativeBundleStatus(BUNDLE_UNAVAILABLE_MESSAGE);
          return false;
        }
      }

      async function refreshBundleUi(forceRender) {
        if (bundleUiRuntime.inFlight) {
          bundleUiRuntime.pending = true;
          window.__mdlBundleRefreshPending = true;
          return;
        }
        bundleUiRuntime.inFlight = true;
        window.__mdlBundleRefreshInFlight = true;
        window.__mdlBundleRefreshPending = false;
        const initialRenderedCardsCount = document.querySelectorAll('[data-mdl-bundle-item]').length;
        const isInitialRender = !IS_ONEA_PARURE
          && !bundleUiRuntime.initialRenderComplete
          && initialRenderedCardsCount === 0;
        if (!isInitialRender) {
          window.dispatchEvent(new CustomEvent('mdl:bundle-refresh-state', { detail: { active: true } }));
        }
        let loadingToken = 0;
        let toggledLoading = false;
        try {
          enforceNativeBundleUi();
          bindGlobalSizeSelector();
          const currentVariantId = resolveCurrentParentVariantId();
          const renderedCardsCount = document.querySelectorAll('[data-mdl-bundle-item]').length;
          const shouldRender = !IS_ONEA_PARURE && Boolean(
            forceRender
            || renderedCardsCount === 0
            || (currentVariantId && currentVariantId !== bundleUiRuntime.lastRenderedVariantId)
          );
          if (shouldRender) {
            loadingToken = setBundleLoadingState(true, { silent: isInitialRender });
            toggledLoading = true;
            const rendered = await ensureAndRenderRuntimeBundleComponents();
            if (rendered) {
              bundleUiRuntime.lastRenderedVariantId = currentVariantId;
              bundleUiRuntime.renderFailures = 0;
            } else {
              bundleUiRuntime.renderFailures += 1;
            }
          }
          const currentParentVariant = getCurrentParentVariant();
          syncBundlePriceDisplay(getCurrentRuntimeParentVariant());
          syncGlobalSizeSelectorFromParentVariant(currentParentVariant);
          syncGlobalSizeOptionAvailability(currentParentVariant);
          syncParentVariantIdInputs(currentParentVariant);
          syncNativeVariantOptionInputs(currentParentVariant);
          syncVariantSyncedSwatchesFromParentVariant();
          syncParentVariantIdInputs(currentParentVariant);
          syncBundleColorSelector(currentParentVariant);
          syncNativeBundleAtcState();
          applyPackAdvantageBadgeLabelDeferred();
        } finally {
          if (toggledLoading) {
            setBundleLoadingState(false, { token: loadingToken, silent: isInitialRender });
          } else {
            setBundleLoadingState(false, { force: true, silent: isInitialRender });
          }
          if (document.querySelectorAll('[data-mdl-bundle-item]').length > 0) {
            bundleUiRuntime.initialRenderComplete = true;
          }
          bundleUiRuntime.inFlight = false;
          window.__mdlBundleRefreshInFlight = false;
          applyPackAdvantageBadgeLabelDeferred();
          if (bundleUiRuntime.pending) {
            bundleUiRuntime.pending = false;
            window.__mdlBundleRefreshPending = true;
            window.setTimeout(() => refreshBundleUi(false), 0);
          } else {
            window.__mdlBundleRefreshPending = false;
            if (!isInitialRender) {
              window.dispatchEvent(new CustomEvent('mdl:bundle-refresh-state', { detail: { active: false } }));
            }
          }
        }
      }

      function startBundleWatchdog() {
        if (IS_ONEA_PARURE) return;
        if (bundleUiRuntime.watchdogTimer) return;
        bundleUiRuntime.watchdogTimer = window.setInterval(() => {
          if (bundleUiRuntime.inFlight || window.__mdlBundleLoadingActive) return;
          const currentVariantId = resolveCurrentParentVariantId();
          const cardsCount = document.querySelectorAll('[data-mdl-bundle-item]').length;
          const signature = `${currentVariantId}|${window.location.search}|${cardsCount}`;
          if (signature === bundleUiRuntime.lastWatchdogSignature) return;
          bundleUiRuntime.lastWatchdogSignature = signature;
          if (!currentVariantId) return;
          if (bundleUiRuntime.renderFailures >= 3) return;
          const now = Date.now();
          if (now - bundleUiRuntime.lastWatchdogForceAt < 1200) return;
          if (cardsCount === 0) {
            bundleUiRuntime.lastWatchdogForceAt = now;
            scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
          } else if (currentVariantId !== bundleUiRuntime.lastRenderedVariantId) {
            bundleUiRuntime.lastWatchdogForceAt = now;
            scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
          }
        }, 350);
      }

      function scheduleBundleUiRefresh(options) {
        const delay = options && Number.isFinite(options.delay) ? options.delay : 0;
        const forceRender = Boolean(options && options.forceRender);
        if (bundleUiRuntime.inFlight && !bundleUiRuntime.initialRenderComplete) return;
        if (bundleUiRuntime.timer) window.clearTimeout(bundleUiRuntime.timer);
        bundleUiRuntime.timer = window.setTimeout(() => {
          bundleUiRuntime.timer = null;
          refreshBundleUi(forceRender);
          applyPackVocabularyDeferred();
        }, delay);
      }

      function parentVariantForSwatch(swatchButton) {
        if (!swatchButton) return null;
        const componentKeyValue = String(swatchButton.dataset.mdlComponentKey || '').trim();
        const componentHandle = (componentKeyValue.split('::')[0] || '').toLowerCase();
        const swatchVariant = variantByIdForComponentKey(componentKeyValue, swatchButton.dataset.swatchVariantId);
        const selectedSwatchHeight = componentHandle === 'sommier-somflex' ? variantHeightValue(swatchVariant) : '';
        let localSizeConstraints = selectedLocalComponentSizeConstraints();
        if (selectedSwatchHeight) {
          localSizeConstraints = localSizeConstraints.filter((value) => !/^\d+(?:[.,]\d+)?\s*cm$/i.test(value));
          localSizeConstraints.push(selectedSwatchHeight);
        }
        localSizeConstraints = Array.from(new Set(localSizeConstraints));
        const currentVariant = getCurrentParentVariant();
        const variantMap = getParentVariantMap();
        const swatchLabel = (swatchButton.dataset.swatchLabel || '').trim();
        const fallbackSize = currentVariant ? currentVariant.size : '';
        const swatchColor = String(swatchButton.dataset.swatchHandle || '').trim()
          || (swatchLabel.includes(' / ') ? swatchLabel.split(' / ').pop().trim() : '');
        const expectedColor = normalizeColorValue(swatchColor);
        const explicitParentVariantId = String(swatchButton.dataset.swatchParentVariantId || '').trim();
        if (explicitParentVariantId) {
          const explicitVariant = getParentVariantById(explicitParentVariantId);
          const explicitMatchesSize = !fallbackSize || String(explicitVariant && explicitVariant.size || '').trim() === String(fallbackSize).trim();
          const explicitMatchesColor = !expectedColor || normalizeColorValue(explicitVariant && explicitVariant.color) === expectedColor;
          if (explicitVariant && explicitMatchesSize && explicitMatchesColor && parentVariantMatchesLocalSizeConstraints(explicitVariant, localSizeConstraints)) return explicitVariant;
        }
        if (constrainedVariantId && variantMap[constrainedVariantId]) return variantMap[constrainedVariantId];

        return Object.values(variantMap).find((variant) => {
          if (!variant || !variant.color) return false;
          if (!parentVariantMatchesLocalSizeConstraints(variant, localSizeConstraints)) return false;
          const label = `${variant.size} / ${variant.color}`;
          if (swatchLabel === label) return true;
          return Boolean(fallbackSize && variant.size === fallbackSize && swatchLabel.endsWith(` / ${variant.color}`));
        }) || null;
      }

      function syncBundleSyncedSwatchAvailability() {
        const swatchRoots = document.querySelectorAll('[data-mdl-variant-synced-swatches]');
        if (!swatchRoots.length) return;

        swatchRoots.forEach((swatchRoot) => {
          const mode = String(swatchRoot.dataset.mdlSwatchMode || '').trim();
          getSwatchElements(swatchRoot).forEach((button) => {
            if (mode === 'component') {
              const componentAvailable = button.dataset.swatchAvailable !== 'false';
              button.dataset.mdlBundleUnavailable = componentAvailable ? 'false' : 'true';
              button.setAttribute('aria-disabled', componentAvailable ? 'false' : 'true');
              button.setAttribute('tabindex', componentAvailable ? '0' : '-1');
              return;
            }
            if (mode !== 'parent') return;
            const parentVariant = parentVariantForSwatch(button);
            const componentAvailable = button.dataset.swatchAvailable !== 'false';
            const isAvailable = Boolean(componentAvailable && parentVariant && parentVariant.available);
            button.dataset.mdlBundleUnavailable = isAvailable ? 'false' : 'true';
            button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
            if (!isAvailable) {
              button.setAttribute('tabindex', '-1');
              button.setAttribute('aria-pressed', 'false');
              button.classList.remove('is-active');
            } else if (!button.hasAttribute('tabindex') || button.getAttribute('tabindex') === '-1') {
              button.setAttribute('tabindex', '0');
            }
          });
        });
      }

      function setCurrentParentVariantBySwatch(swatchButton) {
        if (bundleUiRuntime.swatchSyncLock) return false;
        bundleUiRuntime.swatchSyncLock = true;
        try {
        const nextParentVariant = parentVariantForSwatch(swatchButton);
        if (!nextParentVariant || !nextParentVariant.id) return false;
        const nextVariantId = String(nextParentVariant.id);
        if (!commitParentVariantSelection(nextParentVariant)) return false;
        const convergedVariantId = resolveCurrentParentVariantId();
        if (convergedVariantId !== nextVariantId && Array.isArray(nextParentVariant.option_value_ids) && nextParentVariant.option_value_ids.length) {
          const optionValuesFallback = nextParentVariant.option_value_ids.filter(Boolean).join(',');
          if (optionValuesFallback) {
            const fallbackUrl = new URL(window.location.href);
            fallbackUrl.searchParams.set('option_values', optionValuesFallback);
            window.location.assign(fallbackUrl.toString());
            return false;
          }
        }
        return true;
        } finally {
          window.setTimeout(() => {
            bundleUiRuntime.swatchSyncLock = false;
          }, 0);
        }
      }

      function hideNativeBundleColorOptionControls() {
        if (!HIDE_NATIVE_COLOR_OPTION) return;
        const allowedNames = Array.from(new Set(
          [...(Array.isArray(PARENT_COLOR_OPTION_NAMES) ? PARENT_COLOR_OPTION_NAMES : []), PARENT_COLOR_OPTION_NAME, 'couleur sommier', 'couleur']
            .map((value) => String(value || '').trim().toLowerCase())
            .filter(Boolean)
        ));
        document.querySelectorAll('variant-selector fieldset').forEach((fieldset) => {
          const legendText = (fieldset.querySelector('legend') ? fieldset.querySelector('legend').textContent : '').trim().toLowerCase();
          if (!allowedNames.includes(legendText)) return;
          fieldset.classList.add('mdl-native-bundle-option-hidden');
          fieldset.setAttribute('aria-hidden', 'true');
          fieldset.querySelectorAll('input, select, button, label').forEach((control) => {
            control.setAttribute('tabindex', '-1');
          });
          const previous = fieldset.previousElementSibling;
          if (previous && previous.tagName === 'HR') {
            previous.classList.add('mdl-native-bundle-option-hidden');
            previous.setAttribute('aria-hidden', 'true');
          }
          const next = fieldset.nextElementSibling;
          if (next && next.tagName === 'HR') {
            next.classList.add('mdl-native-bundle-option-hidden');
            next.setAttribute('aria-hidden', 'true');
          }
        });
      }

      function hideNativeBundleSizeOptionControls() {
        if (!HIDE_NATIVE_SIZE_OPTION) return;
        document.querySelectorAll('variant-selector fieldset').forEach((fieldset) => {
          const legend = fieldset.querySelector('legend');
          const legendText = String((legend && legend.textContent) || '').trim().toLowerCase();
          const configuredName = String(SIZE_OPTION_NAME || '').trim().toLowerCase();
          const isSizeFieldset = (configuredName && legendText.includes(configuredName)) || legendText.includes('taille');
          if (!isSizeFieldset) return;
          fieldset.classList.add('mdl-native-bundle-option-hidden');
          fieldset.setAttribute('aria-hidden', 'true');
        });
      }

      function hideNativeBundleVariantTitle() {
        document.querySelectorAll('.product__variant-title').forEach((title) => {
          title.classList.add('mdl-native-bundle-option-hidden');
          title.setAttribute('aria-hidden', 'true');
        });
      }

      function hideBundleTopSeparator() {
        document.querySelectorAll('[data-mdl-bundle-contents]').forEach((bundleRoot) => {
          const rootRect = bundleRoot.getBoundingClientRect();
          const scope = bundleRoot.closest('[product-details]') || bundleRoot.closest('form') || document;
          const separators = Array.from(scope.querySelectorAll('hr'));
          let closestSeparator = null;
          let closestGap = Number.POSITIVE_INFINITY;
          separators.forEach((separator) => {
            const separatorRect = separator.getBoundingClientRect();
            const isAbove = separatorRect.bottom <= rootRect.top + 2;
            if (!isAbove) return;
            const gap = rootRect.top - separatorRect.bottom;
            if (gap < closestGap) {
              closestGap = gap;
              closestSeparator = separator;
            }
          });
          if (closestSeparator) {
            closestSeparator.classList.add('mdl-native-bundle-option-hidden');
            closestSeparator.setAttribute('aria-hidden', 'true');
          }
        });
      }

      function optionFieldsetsWithLegendHints(hints) {
        const normalizedHints = (Array.isArray(hints) ? hints : [])
          .map((hint) => String(hint || '').trim().toLowerCase())
          .filter(Boolean);
        if (!normalizedHints.length) return [];
        return Array.from(document.querySelectorAll('variant-selector fieldset')).filter((fieldset) => {
          const legend = fieldset.querySelector('legend');
          const text = String((legend && legend.textContent) || '').trim().toLowerCase();
          return normalizedHints.some((hint) => text.includes(hint));
        });
      }

      function reorderNativeBundleOptionControls() {
        const sizeFieldset = optionFieldsetsWithLegendHints([SIZE_OPTION_NAME, 'taille'])[0];
        const colorFieldset = optionFieldsetsWithLegendHints([PARENT_COLOR_OPTION_NAME, 'couleur sommier', 'couleur'])[0];
        if (!sizeFieldset || !colorFieldset) return;
        const parent = sizeFieldset.parentElement;
        if (!parent || colorFieldset.parentElement !== parent) return;
        parent.insertBefore(sizeFieldset, colorFieldset);
      }

      function setNativeBundleStatus(message) {
        const status = document.querySelector('[data-mdl-native-bundle-atc-status]');
        if (!status) return;
        status.textContent = message || '';
      }

      function hideDuplicateBundleAtcButtons() {
        document.querySelectorAll('button, input[type="submit"], [type="submit"], [data-main-add-to-cart], .btn-add').forEach((submit) => {
          if (submit.closest('[data-mdl-bundle-contents]')) return;
          if (submit.matches('[data-mdl-native-bundle-atc]')) return;
          const label = String(submit.innerText || submit.value || submit.textContent || '').trim().toLowerCase();
          if (!label.includes('ajouter') && !label.includes('panier') && !submit.matches('button[type="submit"], input[type="submit"], [type="submit"], [data-main-add-to-cart], .btn-add')) return;
          submit.classList.add('mdl-native-bundle-core-atc-hidden');
          submit.setAttribute('aria-hidden', 'true');
          submit.setAttribute('tabindex', '-1');
          submit.setAttribute('disabled', 'disabled');
        });
      }

      function enforceSingleCustomBundleAtc() {
        const buttons = Array.from(document.querySelectorAll('[data-mdl-native-bundle-atc]'));
        if (buttons.length <= 1) return;
        buttons.forEach((button, index) => {
          if (index === 0) return;
          button.classList.add('mdl-native-bundle-core-atc-hidden');
          button.setAttribute('aria-hidden', 'true');
          button.setAttribute('tabindex', '-1');
          button.setAttribute('disabled', 'disabled');
        });
      }

      function isNativeBundleAtcTrigger(target) {
        if (!target || typeof target.closest !== 'function') return false;
        const trigger = target.closest('button, input[type="submit"], [type="submit"], [data-main-add-to-cart], .btn-add');
        if (!trigger || trigger.closest('[data-mdl-bundle-contents]')) return false;
        const form = trigger.closest('form');
        if (!form || !String(form.getAttribute('action') || '').includes('/cart/add')) return false;
        const label = String(trigger.innerText || trigger.value || trigger.textContent || '').trim().toLowerCase();
        return label.includes('ajouter') || label.includes('panier') || trigger.matches('[data-main-add-to-cart], .btn-add, [type="submit"]');
      }

      function enforceNativeBundleUi() {
        reorderNativeBundleOptionControls();
        markConfigurablePackNativeOptions();
        enforceSingleCustomBundleAtc();
        hideDuplicateBundleAtcButtons();
        hideBundleTopSeparator();
        hideNativeBundleSizeOptionControls();
        hideNativeBundleColorOptionControls();
        hideNativeBundleVariantTitle();
        positionConfigurablePackControls();
        syncConfigurablePackControlsFromParentVariant(getCurrentParentVariant());
        bindNativeBundleAtcButton();
        applyBundleStepSpacing();
      }

      function reconcileRequestedGlobalSizeAfterDomRepair() {
        const requestedSize = selectedRequestedGlobalSizeValue();
        if (!requestedSize) return false;
        const current = getNativeSelectedParentVariant() || getCurrentParentVariant();
        const preferredColor = current ? current.color : activeVariantSyncedSwatchColor();
        const localSizeConstraints = selectedLocalComponentSizeConstraints();
        const nextVariantId = findParentVariantIdBySizePreservingOptions(requestedSize, current, preferredColor, localSizeConstraints)
          || findParentVariantIdBySizeColorAndLocalConstraints(requestedSize, preferredColor, localSizeConstraints)
          || findParentVariantIdBySizeColorAndLocalConstraints(requestedSize, '', localSizeConstraints)
          || (!localSizeConstraints.length ? (findParentVariantIdBySize(requestedSize, preferredColor) || findParentVariantIdBySize(requestedSize, '')) : '');
        const nextParentVariant = nextVariantId ? getParentVariantById(nextVariantId) : null;
        if (!nextParentVariant) return false;
        setRequestedGlobalSizeValue(requestedSize, 8000);
        const select = document.querySelector('[data-mdl-bundle-global-size-select]');
        if (select && String(select.value || '').trim() !== requestedSize) select.value = requestedSize;
        return commitParentVariantSelection(nextParentVariant);
      }

      function scheduleBundleDomRepair() {
        if (bundleUiRuntime.domRepairTimer) window.clearTimeout(bundleUiRuntime.domRepairTimer);
        bundleUiRuntime.domRepairTimer = window.setTimeout(() => {
          bundleUiRuntime.domRepairTimer = null;
          enforceNativeBundleUi();
          reconcileRequestedGlobalSizeAfterDomRepair();
          bundleUiRuntime.lastRenderedVariantId = '';
          scheduleBundleUiRefresh({ delay: 0, forceRender: true });
        }, 40);
      }

      function startBundleDomRepairObserver() {
        if (IS_ONEA_PARURE) return;
        const root = document.querySelector('form-controller') || document.body || document.documentElement;
        if (!root || bundleUiRuntime.domRepairObserver) return;
        bundleUiRuntime.domRepairObserver = new MutationObserver((mutations) => {
          const shouldRepair = mutations.some((mutation) => {
            return Array.from(mutation.addedNodes || []).some((node) => {
              if (!node || node.nodeType !== 1) return false;
              if (node.matches && (
                node.matches('[data-mdl-bundle-contents]')
                || node.matches('[data-mdl-native-bundle-atc]')
                || node.matches('[data-mdl-bundle-runtime-list]')
                || node.matches('variant-selector')
              )) return true;
              return Boolean(node.querySelector && (
                node.querySelector('[data-mdl-bundle-contents]')
                || node.querySelector('[data-mdl-native-bundle-atc]')
                || node.querySelector('[data-mdl-bundle-runtime-list]')
                || node.querySelector('variant-selector')
              ));
            });
          });
          if (shouldRepair) scheduleBundleDomRepair();
        });
        bundleUiRuntime.domRepairObserver.observe(root, { childList: true, subtree: true });
      }

      function bindNativeBundleAtcButton() {
        const button = document.querySelector('[data-mdl-native-bundle-atc]');
        if (!button) return;
        button.onclick = (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          postNativeBundleParentFromButton();
        };
        if (button.dataset.mdlAtcBound === 'true') return;
        button.dataset.mdlAtcBound = 'true';
      }

      async function postNativeBundleParentFromButton() {
        const button = document.querySelector('[data-mdl-native-bundle-atc]');
        const targetVariantId = resolveCurrentParentVariantId() || getCurrentParentVariantId();
        if (!/^\d+$/.test(String(targetVariantId || ''))) {
          syncNativeBundleAtcState();
          return;
        }
        bundleUiRuntime.lastUserSelectedParentVariantId = targetVariantId;
        if (button) button.setAttribute('disabled', 'disabled');
        setNativeBundleStatus('');
        syncParentVariantIdInputs({ id: targetVariantId });
        await new Promise(resolve => setTimeout(resolve, 0));
        syncParentVariantIdInputs({ id: targetVariantId });
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              id: Number(targetVariantId),
              quantity: 1
            })
          });
          if (!response.ok) {
            let errorMessage = BUNDLE_UNAVAILABLE_MESSAGE;
            try {
              const payload = await response.json();
              errorMessage = payload.description || payload.message || errorMessage;
            } catch (error) {}
            throw new Error(errorMessage);
          }
          document.dispatchEvent(new Event('cart:updated'));
          window.pdpAtcToast?.open('Votre panier a bien été mis à jour.');
        } catch (error) {
          if (button) button.removeAttribute('disabled');
          setNativeBundleStatus(error && error.message ? error.message : BUNDLE_UNAVAILABLE_MESSAGE);
        }
      }

      function bindGlobalSizeSelector() {
        if (!SHOW_GLOBAL_SIZE_SELECTOR) return;
        const select = document.querySelector('[data-mdl-bundle-global-size-select]');
        if (!select || select.dataset.mdlBound === 'true') return;
        select.dataset.mdlBound = 'true';
        select.addEventListener('change', () => handleGlobalSizeSelectorChange(select));
      }

      function handleGlobalSizeSelectorChange(select) {
        if (!SHOW_GLOBAL_SIZE_SELECTOR || !select) return;
        const requestedSize = String(select.value || '').trim();
        if (!requestedSize) return;
        const current = getNativeSelectedParentVariant() || getCurrentParentVariant();
        setRequestedGlobalSizeValue(requestedSize, 8000);
        const preferredColor = current ? current.color : '';
        const localSizeConstraints = selectedLocalComponentSizeConstraints();
        const nextVariantId = findParentVariantIdBySizePreservingOptions(requestedSize, current, preferredColor, localSizeConstraints)
          || findParentVariantIdBySizeColorAndLocalConstraints(requestedSize, preferredColor, localSizeConstraints)
          || findParentVariantIdBySizeColorAndLocalConstraints(requestedSize, '', localSizeConstraints)
          || (!localSizeConstraints.length ? (findParentVariantIdBySize(requestedSize, preferredColor) || findParentVariantIdBySize(requestedSize, '')) : '');
        if (!nextVariantId) return;
        const map = getParentVariantMap();
        const nextParentVariant = map[nextVariantId];
        if (!nextParentVariant) return;
        commitParentVariantSelection(nextParentVariant);
        if (IS_ONEA_PARURE) {
          syncBundleColorSelector(nextParentVariant);
          syncGlobalSizeOptionAvailability(nextParentVariant);
          reinforceGlobalSizeSelection(nextParentVariant, requestedSize, nextParentVariant.color, current);
          syncNativeBundleAtcState();
          return;
        }
        reinforceGlobalSizeSelection(nextParentVariant, requestedSize, '', current);
        bundleUiRuntime.lastRenderedVariantId = '';
        scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
      }

      function reinforceGlobalSizeSelection(parentVariant, requestedSize, preferredColorOverride, preservationVariant) {
        const initialColor = String(preferredColorOverride || (parentVariant ? parentVariant.color : '') || '').trim();
        const reinforcementDelays = IS_ONEA_PARURE ? [0, 180, 600] : [0, 120, 450, 900, 1600];
        reinforcementDelays.forEach((delay) => {
          window.setTimeout(() => {
            const select = document.querySelector('[data-mdl-bundle-global-size-select]');
            if (select && requestedSize) {
              setRequestedGlobalSizeValue(requestedSize, 8000);
              if (String(select.value || '').trim() !== requestedSize) {
                select.value = requestedSize;
              }
            }
            const current = preservationVariant || getNativeSelectedParentVariant() || getCurrentParentVariant();
            const currentColor = current ? String(current.color || '').trim() : '';
            const preferredColor = initialColor || currentColor;
            const localSizeConstraints = selectedLocalComponentSizeConstraints();
            const nextVariantId = findParentVariantIdBySizePreservingOptions(requestedSize, current, preferredColor, localSizeConstraints)
              || findParentVariantIdBySizeColorAndLocalConstraints(requestedSize, preferredColor, localSizeConstraints)
              || findParentVariantIdBySizeColorAndLocalConstraints(requestedSize, '', localSizeConstraints)
              || (!localSizeConstraints.length ? (findParentVariantIdBySize(requestedSize, preferredColor) || findParentVariantIdBySize(requestedSize, '')) : '');
            const nextParentVariant = nextVariantId ? getParentVariantById(nextVariantId) : null;
            if (nextParentVariant) {
              const currentNativeVariantId = parentVariantIdByOptionValueIds(optionValueIdsFromVariantInputs());
              if (currentNativeVariantId !== String(nextParentVariant.id || '')) {
                commitParentVariantSelection(nextParentVariant);
              }
            }
            if (!IS_ONEA_PARURE) {
              const targetVariantId = String(nextParentVariant && nextParentVariant.id || '');
              const renderedVariantId = String(bundleUiRuntime.lastRenderedVariantId || '');
              const listHasItems = Boolean(document.querySelector('[data-mdl-bundle-runtime-list] [data-mdl-bundle-item]'));
              if (targetVariantId && (!listHasItems || renderedVariantId !== targetVariantId)) {
                bundleUiRuntime.lastRenderedVariantId = '';
                scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
              }
            } else if (nextParentVariant) {
              syncBundleColorSelector(nextParentVariant);
            }
          }, delay);
        });
        window.setTimeout(() => {
          clearRequestedGlobalSizeValue(requestedSize);
        }, IS_ONEA_PARURE ? 1600 : 8500);
      }

      function setComponentSelection(componentKeyValue, variant) {
        const key = String(componentKeyValue || '').trim();
        if (!key || !variant) return;
        bundleUiRuntime.componentSelections[key] = {
          variantId: String(variant.id || '').trim(),
          variantTitle: String(variant.title || '').trim(),
        };
      }

      function variantByIdForComponentKey(componentKeyValue, variantId) {
        const key = String(componentKeyValue || '').trim();
        const targetVariantId = String(variantId || '').trim();
        if (!key || !targetVariantId) return null;
        const handle = key.split('::')[0] || '';
        const variants = storefrontRuntime.syncedHandleVariants[handle] || [];
        return variants.find((variant) => String(variant.id || '').trim() === targetVariantId) || null;
      }

      function applyBundleStepSpacing() {
        const stepHeading = Array.from(document.querySelectorAll('p > strong'))
          .find((node) => {
            const raw = (node.textContent || '').trim().toLowerCase();
            return raw.includes('chois') && raw.includes('taille');
          });
        if (!stepHeading || !stepHeading.parentElement) return;
        stepHeading.parentElement.style.display = 'none';
      }

      function syncNativeBundleAtcState() {
        const button = document.querySelector('[data-mdl-native-bundle-atc]');
        if (!button) return;
        const currentVariant = getCurrentParentVariant();
        const isAvailable = Boolean(currentVariant && currentVariant.available);
        button.disabled = !isAvailable;
        button.dataset.mdlBundleAvailable = isAvailable ? 'true' : 'false';
        button.textContent = isAvailable ? BUNDLE_ATC_TEXT : BUNDLE_UNAVAILABLE_TEXT;
        setNativeBundleStatus(isAvailable ? '' : BUNDLE_UNAVAILABLE_MESSAGE);
      }

      function syncVariantSyncedSwatchesFromParentVariant() {
        syncBundleSyncedSwatchAvailability();
        const currentVariant = getCurrentParentVariant();
        if (!currentVariant || !currentVariant.color) return;
        const swatchRoots = document.querySelectorAll('[data-mdl-variant-synced-swatches][data-mdl-swatch-mode="parent"]');
        swatchRoots.forEach((swatchRoot) => {
          const swatch = getSwatchElements(swatchRoot).find((button) => {
            const byParentVariantId = String(button.dataset.swatchParentVariantId || '').trim() === String(currentVariant.id || '').trim();
            if (byParentVariantId) return true;
            const sameSize = String(button.dataset.swatchLabel || '').trim().startsWith(`${String(currentVariant.size || '').trim()} / `);
            const sameColor = normalizeColorValue(button.dataset.swatchHandle || '') === normalizeColorValue(currentVariant.color || '');
            return Boolean(sameSize && sameColor);
          });
          if (!swatch) return;
          if (isSwatchUnavailable(swatch)) return;
          applySwatchPreview(swatchRoot, swatch);
          setSwatchSelection(swatchRoot, swatch);
        });
      }

      async function addNativeBundleParent() {
        const button = document.querySelector('[data-mdl-native-bundle-atc]');
        const resolvedParentId = resolveCurrentParentVariantId() || getCurrentParentVariantId();
        const currentVariant = getParentVariantById(resolvedParentId)
          || getParentVariantById(
            findParentVariantIdBySize(selectedGlobalSizeValue(), activeVariantSyncedSwatchColor())
          )
          || (/^\d+$/.test(String(resolvedParentId || '')) ? { id: resolvedParentId, available: true } : null);
        if (!currentVariant || !currentVariant.available) {
          syncNativeBundleAtcState();
          return;
        }
        const targetVariantId = String(currentVariant.id || '').trim();
        if (!targetVariantId) {
          syncNativeBundleAtcState();
          return;
        }
        bundleUiRuntime.lastUserSelectedParentVariantId = targetVariantId;
        if (button) button.setAttribute('disabled', 'disabled');
        setNativeBundleStatus('');
        try {
          syncParentVariantIdInputs(currentVariant);
          syncNativeVariantOptionInputs(currentVariant);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                id: Number(targetVariantId),
                quantity: 1
              })
            });
          if (!response.ok) {
            let errorMessage = BUNDLE_UNAVAILABLE_MESSAGE;
            try {
              const payload = await response.json();
              errorMessage = payload.description || payload.message || errorMessage;
            } catch (error) {}
            throw new Error(errorMessage);
          }
          document.dispatchEvent(new Event('cart:updated'));
          window.pdpAtcToast?.open('Votre panier a bien été mis à jour.');
        } catch (error) {
          if (button) button.removeAttribute('disabled');
          setNativeBundleStatus(error && error.message ? error.message : BUNDLE_UNAVAILABLE_MESSAGE);
        }
      }

      document.addEventListener('submit', (event) => {
        if (!event.target || typeof event.target.querySelector !== 'function') return;
        const duplicateAtc = event.target.querySelector('.mdl-native-bundle-core-atc-hidden, [data-main-add-to-cart], .btn-add');
        if (!duplicateAtc) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        postNativeBundleParentFromButton();
      }, true);

      document.addEventListener('click', (event) => {
        if (isNativeBundleAtcTrigger(event.target)) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          postNativeBundleParentFromButton();
          return;
        }

        const nativeAtc = event.target.closest('[data-mdl-native-bundle-atc]');
        if (nativeAtc) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          postNativeBundleParentFromButton();
          return;
        }

        const colorOption = event.target.closest('[data-mdl-bundle-color-option]');
        if (colorOption) {
          event.preventDefault();
          event.stopPropagation();
          handleBundleColorOption(colorOption);
          return;
        }

        if (event.target.closest('[data-mdl-component-size-select]') || event.target.closest('[data-mdl-component-swatch="true"]') || event.target.closest('[data-mdl-pack-card-choice]')) {
          return;
        }

        const swatch = event.target.closest('[data-mdl-swatch]');
        if (swatch) return;

        const trigger = event.target.closest('[data-mdl-bundle-modal-target]');
        if (!trigger) return;

        const modal = document.getElementById(trigger.dataset.mdlBundleModalTarget);
        if (!modal || typeof modal.showModal !== 'function') return;
        formatBundleModalDescription(modal);
        modal.showModal();
        document.documentElement.classList.add('mdl-bundle-modal-open');
        document.body.classList.add('mdl-bundle-modal-open');
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const colorOption = event.target.closest('[data-mdl-bundle-color-option]');
        if (colorOption) {
          event.preventDefault();
          event.stopPropagation();
          handleBundleColorOption(colorOption);
          return;
        }
        const trigger = event.target.closest('[data-mdl-bundle-modal-trigger="true"]');
        if (!trigger) return;
        if (event.target.closest('[data-mdl-component-size-select]') || event.target.closest('[data-mdl-component-swatch="true"]') || event.target.closest('[data-mdl-pack-card-choice]')) return;
        event.preventDefault();
        const modal = document.getElementById(trigger.dataset.mdlBundleModalTarget);
        if (!modal || typeof modal.showModal !== 'function') return;
        formatBundleModalDescription(modal);
        modal.showModal();
        document.documentElement.classList.add('mdl-bundle-modal-open');
        document.body.classList.add('mdl-bundle-modal-open');
      });

      document.addEventListener('click', (event) => {
        const close = event.target.closest('[data-mdl-bundle-modal-close]');
        if (!close) return;

        const modal = close.closest('dialog');
        if (modal) {
          modal.close();
          unlockBundleModalScroll();
        }
      });

      document.addEventListener('click', (event) => {
        if (event.target instanceof HTMLDialogElement) {
          event.target.close();
          unlockBundleModalScroll();
        }
      });

      function makeListItem(html) {
        const li = document.createElement('li');
        li.innerHTML = html.replace(/^•\s*/, '').trim();
        return li;
      }

      function formatBundleModalDescription(modal) {
        const body = modal.querySelector('.mdl-bundle-modal__description');
        if (!body || body.dataset.mdlFormatted === 'true') return;

        Array.from(body.querySelectorAll('p')).forEach((paragraph) => {
          const html = paragraph.innerHTML;
          if (!html.includes('•')) return;

          const normalized = html.replace(/<br\s*\/?>/gi, '<br>');
          const parts = normalized.split(/<br>\s*•\s*/);
          if (parts.length > 1) {
            const intro = parts.shift().trim();
            const list = document.createElement('ul');
            parts.forEach((part) => {
              if (part.trim()) list.appendChild(makeListItem(part));
            });

            if (intro && intro !== '•') {
              paragraph.innerHTML = intro;
              paragraph.insertAdjacentElement('afterend', list);
            } else {
              paragraph.replaceWith(list);
            }
          }
        });

        let activeList = null;
        Array.from(body.children).forEach((child) => {
          if (child.tagName !== 'P') {
            activeList = null;
            return;
          }

          if (!child.textContent.trim().startsWith('•')) {
            activeList = null;
            return;
          }

          if (!activeList) {
            activeList = document.createElement('ul');
            child.insertAdjacentElement('beforebegin', activeList);
          }
          activeList.appendChild(makeListItem(child.innerHTML));
          child.remove();
        });

        body.dataset.mdlFormatted = 'true';
      }

      document.addEventListener('pointerover', (event) => {
        const swatch = event.target.closest('[data-mdl-swatch]');
        if (isSwatchUnavailable(swatch)) return;
        if (swatch) {
          applySwatchPreview(swatch.closest('[data-mdl-variant-synced-swatches]'), swatch);
        }
      });

      document.addEventListener('focusin', (event) => {
        const swatch = event.target.closest('[data-mdl-swatch]');
        if (isSwatchUnavailable(swatch)) return;
        if (swatch) {
          applySwatchPreview(swatch.closest('[data-mdl-variant-synced-swatches]'), swatch);
        }
      });

      document.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-mdl-swatch]');
        if (!swatch) return;
        const swatchRoot = swatch.closest('[data-mdl-variant-synced-swatches]');
        if (!swatchRoot) return;
        event.preventDefault();
        event.stopPropagation();
        const swatchMode = String(swatchRoot.dataset.mdlSwatchMode || '').trim();
        if (swatchMode === 'component') {
          if (swatch.dataset.swatchAvailable === 'false') return;
          const key = String(swatch.dataset.mdlComponentKey || '').trim();
          const variant = variantByIdForComponentKey(key, swatch.dataset.swatchVariantId);
          const swatchParentVariantId = String(swatch.dataset.swatchParentVariantId || '').trim();
          if (swatchParentVariantId) {
            bundleUiRuntime.lastUserSelectedParentVariantId = swatchParentVariantId;
          }
          const parentVariantSwitched = swatchParentVariantId ? setCurrentParentVariantBySwatch(swatch) : false;
          if (variant) {
            setComponentSelection(key, variant);
            applySwatchPreview(swatchRoot, swatch);
            setSwatchSelection(swatchRoot, swatch);
            bundleUiRuntime.lastRenderedVariantId = '';
            scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
          }
          if (parentVariantSwitched && !variant) {
            bundleUiRuntime.lastRenderedVariantId = '';
            scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
          }
          return;
        }
        if (swatchMode !== 'parent') return;
        if (isSwatchUnavailable(swatch)) return;
        const parentSwatchParentVariantId = String(swatch.dataset.swatchParentVariantId || '').trim();
        if (parentSwatchParentVariantId) {
          bundleUiRuntime.lastUserSelectedParentVariantId = parentSwatchParentVariantId;
        }
        const variantSwitched = setCurrentParentVariantBySwatch(swatch);
        applySwatchPreview(swatchRoot, swatch);
        setSwatchSelection(swatchRoot, swatch);
        if (variantSwitched) {
          bundleUiRuntime.lastRenderedVariantId = '';
          scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
        }
      });

      const interceptConfigurablePackCardChoice = (event) => {
        if (!CONFIGURABLE_PACK_OPTIONS || !(event.target instanceof Element)) return;
        const cardChoice = event.target.closest('[data-mdl-pack-card-heat-select], [data-mdl-pack-card-firmness-select], [data-mdl-pack-card-heat-option], [data-mdl-pack-card-firmness-option]');
        if (!cardChoice) return;
        event.stopPropagation();
        if (event.type === 'change') window.setTimeout(() => syncConfigurablePackVariantFromControls(), 0);
      };
      document.addEventListener('input', interceptConfigurablePackCardChoice, true);
      document.addEventListener('change', interceptConfigurablePackCardChoice, true);

      document.addEventListener('change', (event) => {
        if (CONFIGURABLE_PACK_OPTIONS && !window.__mdlPackChoiceSyncing && !window.__mdlBundleNativeOptionSyncing) {
          const packSelect = event.target.closest('[data-mdl-pack-combined-select]');
          const packFirmness = event.target.closest('[data-mdl-pack-firmness-option], [data-mdl-pack-card-firmness-option], [data-mdl-pack-card-firmness-select]');
          const packHeat = event.target.closest('variant-selector fieldset.mdl-pack-native-heat');
          if (packSelect || packFirmness || packHeat) {
            window.setTimeout(() => syncConfigurablePackVariantFromControls(), 0);
            return;
          }
        }
        const globalSizeSelect = event.target.closest('[data-mdl-bundle-global-size-select]');
        if (globalSizeSelect) {
          handleGlobalSizeSelectorChange(globalSizeSelect);
          return;
        }

        const sizeSelect = event.target.closest('[data-mdl-component-size-select]');
        if (!sizeSelect) return;
        const key = String(sizeSelect.dataset.mdlComponentKey || '').trim();
        const requestedSize = String(sizeSelect.value || '').trim();
        if (!key || !requestedSize) return;
        const handle = key.split('::')[0] || '';
        const variants = storefrontRuntime.syncedHandleVariants[handle] || [];
        const currentSelection = bundleUiRuntime.componentSelections[key];
        const currentColor = currentSelection
          ? variantColorValue(variants.find((variant) => String(variant.id) === String(currentSelection.variantId)))
          : '';
        let nextVariant = null;
        if (currentColor) {
          nextVariant = variants.find((variant) => {
            return String(variantSizeValue(variant)).trim() === requestedSize
              && String(variantColorValue(variant)).trim() === String(currentColor).trim();
          }) || null;
        }
        if (!nextVariant) {
          nextVariant = variants.find((variant) => String(variantSizeValue(variant)).trim() === requestedSize) || null;
        }
        if (!nextVariant) return;
        setComponentSelection(key, nextVariant);
        const parentCommitted = reconcileParentVariantWithLocalSizeConstraints()
          || commitParentVariantForComponentVariant(nextVariant);
        if (parentCommitted) {
          const resolvedParentVariant = getParentVariantById(resolveCurrentParentVariantId());
          if (resolvedParentVariant && parentVariantMatchesLocalSizeConstraints(resolvedParentVariant)) {
            commitParentVariantSelection(resolvedParentVariant);
          }
        }
        bundleUiRuntime.lastRenderedVariantId = '';
        scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
      });

      document.addEventListener('change', (event) => {
        if (CONFIGURABLE_PACK_OPTIONS && !window.__mdlPackChoiceSyncing) {
          const packControl = event.target.closest('[data-mdl-pack-combined-select], [data-mdl-pack-firmness-option], [data-mdl-pack-card-choice], [data-mdl-pack-card-heat-select], [data-mdl-pack-card-firmness-select], variant-selector fieldset.mdl-pack-native-heat');
          if (packControl) return;
        }
        if (event.target && event.target.closest && event.target.closest('[data-mdl-bundle-global-size-select]')) return;
        if (IS_ONEA_PARURE) return;
        if (!(event.target instanceof Element) || !event.target.closest('form-controller')) return;
        window.setTimeout(() => {
          reconcileParentVariantWithLocalSizeConstraints();
        }, 0);
        scheduleBundleUiRefresh({ delay: 40 });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const swatch = event.target.closest('[data-mdl-swatch]');
        if (!swatch) return;
        const swatchRoot = swatch.closest('[data-mdl-variant-synced-swatches]');
        if (!swatchRoot) return;
        event.preventDefault();
        event.stopPropagation();
        const swatchMode = String(swatchRoot.dataset.mdlSwatchMode || '').trim();
        if (swatchMode === 'component') {
          if (swatch.dataset.swatchAvailable === 'false') return;
          const key = String(swatch.dataset.mdlComponentKey || '').trim();
          const variant = variantByIdForComponentKey(key, swatch.dataset.swatchVariantId);
          const keydownSwatchParentVariantId = String(swatch.dataset.swatchParentVariantId || '').trim();
          if (keydownSwatchParentVariantId) {
            bundleUiRuntime.lastUserSelectedParentVariantId = keydownSwatchParentVariantId;
          }
          const parentVariantSwitched = keydownSwatchParentVariantId ? setCurrentParentVariantBySwatch(swatch) : false;
          if (variant) {
            setComponentSelection(key, variant);
            applySwatchPreview(swatchRoot, swatch);
            setSwatchSelection(swatchRoot, swatch);
            bundleUiRuntime.lastRenderedVariantId = '';
            scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
          }
          if (parentVariantSwitched && !variant) {
            bundleUiRuntime.lastRenderedVariantId = '';
            scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
          }
          return;
        }
        if (swatchMode !== 'parent') return;
        if (isSwatchUnavailable(swatch)) return;
        const keydownParentSwatchParentVariantId = String(swatch.dataset.swatchParentVariantId || '').trim();
        if (keydownParentSwatchParentVariantId) {
          bundleUiRuntime.lastUserSelectedParentVariantId = keydownParentSwatchParentVariantId;
        }
        const variantSwitched = setCurrentParentVariantBySwatch(swatch);
        applySwatchPreview(swatchRoot, swatch);
        setSwatchSelection(swatchRoot, swatch);
        if (variantSwitched) {
          bundleUiRuntime.lastRenderedVariantId = '';
          scheduleBundleUiRefresh({ forceRender: true, delay: 0 });
        }
      });

      document.addEventListener('pointerout', (event) => {
        const swatchRoot = event.target.closest('[data-mdl-variant-synced-swatches]');
        if (!swatchRoot) return;
        const nextTarget = event.relatedTarget;
        if (nextTarget && swatchRoot.contains(nextTarget)) return;
        restoreSelectedSwatchPreview(swatchRoot);
      });

      window.addEventListener('mdl:bundle-parent-variant-sync', (event) => {
        const nextVariantId = String((event.detail && event.detail.variantId) || '').trim();
        if (!nextVariantId) return;
        bundleUiRuntime.lastUserSelectedParentVariantId = nextVariantId;
      });
      window.addEventListener('mdl:product-section:replaced', () => {
        scheduleBundleUiRefresh({ delay: 20, forceRender: true });
        applyPackAdvantageBadgeLabelDeferred();
      });
      window.addEventListener('popstate', () => {
        scheduleBundleUiRefresh({ delay: 20, forceRender: true });
        applyPackAdvantageBadgeLabelDeferred();
      });
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        scheduleBundleUiRefresh({ delay: 20, forceRender: true });
        applyPackAdvantageBadgeLabelDeferred();
      });
      window.addEventListener('resize', scheduleBundleListHeightGuardSync);
      if (!IS_ONEA_PARURE) {
        startBundleWatchdog();
        startBundleDomRepairObserver();
      }
      if (IS_ONEA_PARURE) {
        const pendingDefaultVariantId = String(window.__mdlOneaParureDefaultVariantId || '').trim();
        const hasExplicitVariantContext = Boolean(variantIdFromQueryString() || optionValueIdsFromQueryString().length);
        if (pendingDefaultVariantId && !hasExplicitVariantContext) {
          const pendingDefaultVariantEntry = getParentVariantById(pendingDefaultVariantId);
          if (pendingDefaultVariantEntry) {
            const pendingDefaultParentVariant = Object.assign({}, pendingDefaultVariantEntry, { id: pendingDefaultVariantId });
            bundleUiRuntime.lastUserSelectedParentVariantId = pendingDefaultVariantId;
            const applyDefaultParentVariant = () => {
              const productManager = document.querySelector('product-manager');
              if (!productManager || typeof productManager.setVariantId !== 'function') return false;
              Promise.resolve(productManager.setVariantId(pendingDefaultParentVariant.id)).then(() => {
                syncParentVariantUrl(pendingDefaultParentVariant);
                syncParentVariantIdInputs(pendingDefaultParentVariant);
              }).catch(() => {});
              return true;
            };
            if (!applyDefaultParentVariant()) {
              let defaultAttempts = 0;
              const defaultInterval = window.setInterval(() => {
                defaultAttempts += 1;
                if (applyDefaultParentVariant() || defaultAttempts > 40) {
                  window.clearInterval(defaultInterval);
                }
              }, 100);
              if (window.customElements && typeof window.customElements.whenDefined === 'function') {
                window.customElements.whenDefined('product-manager').then(() => {
                  applyDefaultParentVariant();
                }).catch(() => {});
              }
            }
          }
        }
      }
      window.__mdlBundleRuntimeLoaded = true;
      scheduleBundleUiRefresh({ forceRender: true });
      applyPackAdvantageBadgeLabelDeferred();
      applyPackVocabularyDeferred();
      document.addEventListener('change', (event) => {
        if (!(event.target instanceof Element) || !event.target.closest('form-controller')) return;
        applyPackAdvantageBadgeLabelDeferred();
        applyPackVocabularyDeferred();
      }, true);
      document.addEventListener('variant:change', () => {
        applyPackAdvantageBadgeLabelDeferred();
        applyPackVocabularyDeferred();
      });
      let badgeApplyQueued = false;
      const queuePackBadgeApply = () => {
        if (badgeApplyQueued) return;
        badgeApplyQueued = true;
        window.requestAnimationFrame(() => {
          badgeApplyQueued = false;
          applyPackAdvantageBadgeLabelDeferred();
          applyPackVocabularyDeferred();
        });
      };
      if (!IS_ONEA_PARURE) {
        const badgeObserver = new MutationObserver(() => {
          queuePackBadgeApply();
        });
        document.querySelectorAll('.pdp-price-block, .sticky-add-to-cart, .product-sticky-atc').forEach((root) => {
          badgeObserver.observe(root, { childList: true, subtree: true });
        });
      }
    })();
